// import React, { useState, useEffect, useRef, ChangeEvent } from "react";
// import { Button } from "../../../../Components/ui/button";
// import Default_WhatsApp_background from "../../../../Assets/Default_WhatsApp_background.jpeg";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "../../../../Components/ui/select";
// import { Input } from "../../../../Components/ui/input";
// import { Label } from "../../../../Components/ui/label";
// import { Textarea } from "../../../../Components/ui/textarea";
// import { FaTrash, FaFilePdf } from "react-icons/fa";
// import { PlusIcon, FontBoldIcon, FontItalicIcon, CodeIcon } from "@radix-ui/react-icons";
// import { Smile, Strikethrough } from "lucide-react";
// import EmojiPicker from "emoji-picker-react";
// import { Card } from "../../../../Components/ui/card";
// import emojiRegex from 'emoji-regex';
// import {
//   Dialog,
//   DialogClose,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTrigger,
// } from "../../../../Components/ui/dialog";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import { RootState } from "@/src/State/store";
// import { toast } from "../../../../Components/ui/use-toast";

// interface CountryCode {
//   label: string;
//   value: string;
// }

// interface LanguageOption {
//   label: string;
//   value: string;
// }

// interface RowData {
//   buttonType: string;
//   buttonText: string;
//   buttonTypeDropdown: string;
//   websiteUrl: string;
//   countryCode: string;
//   callPhoneNumber: string;
//   copyOfferCode: string;
//   qrResponse: string;
//   qrOptOut: boolean;
// }

// interface CreateContentWhatsappProps {
//   onClose: () => void;
//   onSave: (content: any) => void;
//   initialContent?: any;
//   allTemplates: any[];
//   configIdx: number;
// }

// interface ValidationErrors {
//   language: string;
//   headerText: string;
//   bodyText: string;
//   footerText: string;
//   mediaFile: string;
//   headerContent: string;
// }

// interface ButtonValidationErrors {
//   buttonText: string;
//   websiteUrl: string;
//   phoneNumber: string;
//   countryCode: string;
//   copyOfferCode: string;
//   general: string;
// }

// // Utility: Extracts media_config from anywhere in the template
// function extractMediaConfig(initialContent: any) {
//   let media_config =
//     initialContent?.media_config ||
//     initialContent?.translated_template?.media_config ||
//     initialContent?.template?.media_config ||
//     initialContent?._debug_original?.media_config;

//   if (
//     (!media_config || !media_config.binary_data) &&
//     Array.isArray(initialContent?.components)
//   ) {
//     const headerComp = initialContent.components.find((c: any) => c.type === "HEADER");
//     if (headerComp?.media_config?.binary_data) {
//       media_config = headerComp.media_config;
//     }
//   }
//   if (
//     (!media_config || !media_config.binary_data) &&
//     Array.isArray(initialContent?.template?.components)
//   ) {
//     const headerComp = initialContent.template.components.find((c: any) => c.type === "HEADER");
//     if (headerComp?.media_config?.binary_data) {
//       media_config = headerComp.media_config;
//     }
//   }
//   return media_config;
// }

// // Validation helper functions
// const containsEmoji = (text: string): boolean => {
//   const regex = emojiRegex();
//   return regex.test(text);
// };

// const normalizeUrl = (raw: string) => {
//   const v = (raw || "").trim();
//   if (!v) return "";
//   if (/^https:\/\//i.test(v)) return v;
//   if (/^www\./i.test(v)) return `https://${v}`;
//   return `https://${v.replace(/^http:\/\//i, "")}`;
// };

// const containsFormatting = (text: string): boolean => {
//   const formattingRegex = /[\*_~`]/;
//   return formattingRegex.test(text);
// };

// const validateLanguage = (language: string): string => {
//   if (!language || language.trim() === '') {
//     return 'Language selection is required';
//   }
//   return '';
// };

// const validateHeaderText = (text: string): string => {
//   if (!text || text.trim() === '') return '';

//   if (containsEmoji(text)) {
//     return 'Header text cannot contain emojis';
//   }

//   if (containsFormatting(text)) {
//     return 'Header text cannot contain formatting characters (*, _, ~, `)';
//   }

//   return '';
// };

// const validateBodyText = (text: string): string => {
//   if (!text || text.trim() === '') {
//     return 'Body text is required';
//   }

//   if (text.trim().length < 25) {
//     return 'Body text must be at least 25 characters long'
//   }
//   return '';
// };

// const validateFooterText = (text: string): string => {
//   if (!text || text.trim() === '') return '';

//   if (containsEmoji(text)) {
//     return 'Footer text cannot contain emojis';
//   }

//   if (containsFormatting(text)) {
//     return 'Footer text cannot contain formatting characters (*, _, ~, `)';
//   }

//   return '';
// };

// const validateMediaFile = (file: File | null): string => {
//   if (!file) return '';

//   const maxSize = 5 * 1024 * 1024;
//   if (file.size > maxSize) {
//     return 'File size must not exceed 5MB';
//   }

//   return '';
// };

// const validateHeaderContent = (headerType: string, textInput: string, hasMedia: boolean): string => {
//   if (headerType === 'none') return '';

//   if (headerType === 'text') {
//     if (!textInput || textInput.trim() === '') {
//       return 'Header text is required when header type is selected';
//     }
//   } else if (['image', 'video', 'document'].includes(headerType)) {
//     if (!hasMedia) {
//       return `${headerType.charAt(0).toUpperCase() + headerType.slice(1)} is required when header type is selected`;
//     }
//   }

//   return '';
// };

// // Button validation functions
// const validateButtonText = (text: string, buttonType: string): string => {
//   if (buttonType === 'COPY_CODE') return '';

//   const v = (text ?? '').trim();
//   if (!v) return 'Button text is required';

//   if (v.length > 25) return 'Button text cannot exceed 25 characters';

//   if (/(https?:\/\/|www\.)/i.test(v)) return 'Do not put URLs in button text';

//   if (!/^[A-Za-z0-9 ]+$/.test(v)) return 'Button text may contain only letters, numbers, and spaces';

//   return '';
// };

// const validateWebsiteUrl = (url: string): string => {
//   if (!url || url.trim() === '') {
//     return 'Website URL is required';
//   }

//   const httpsRegex = /^https:\/\//;
//   const wwwRegex = /^www\./;

//   if (!httpsRegex.test(url) && !wwwRegex.test(url)) {
//     return 'URL must start with https:// or www.';
//   }

//   return '';
// };

// const validatePhoneNumber = (phoneNumber: string): string => {
//   if (!phoneNumber || phoneNumber.trim() === '') {
//     return 'Phone number is required';
//   }

//   const numbersOnlyRegex = /^\d+$/;
//   if (!numbersOnlyRegex.test(phoneNumber)) {
//     return 'Phone number can only contain numbers';
//   }

//   if (phoneNumber.length < 7 || phoneNumber.length > 15) {
//     return 'Phone number must be between 7 and 15 digits';
//   }

//   return '';
// };

// const validateCountryCode = (code: string, buttonType: string): string => {
//   if (buttonType === "PHONE_NUMBER") {
//     if (!code || code.trim() === "") return "Country code is required";
//   }
//   return "";
// };

// const validateCopyOfferCode = (code: string): string => {
//   const v = (code ?? '').trim();
//   if (!v) return 'Offer code is required';

//   if (v.length > 15) return 'Offer code cannot exceed 15 characters';

//   if (!/^[A-Za-z0-9_-]+$/.test(v)) {
//     return 'Only letters, numbers, dashes (-), and underscores (_) are allowed';
//   }

//   if (containsEmoji(v)) return 'Offer code cannot contain emojis';
//   if (/(https?:\/\/|www\.)/i.test(v)) return 'Offer code cannot contain URLs';

//   return '';
// };

// const CreateContentWhatsapp: React.FC<CreateContentWhatsappProps> = ({
//   onClose,
//   onSave,
//   initialContent,
//   allTemplates,
//   configIdx,
// }) => {
//   const [language, setLanguage] = useState("");
//   const [headerType, setHeaderType] = useState<string>("none");
//   const [textInput, setTextInput] = useState<string>("");
//   const [selectedFile, setSelectedFile] = useState<File | null>(null);
//   const [bodyText, setBodyText] = useState<string>("");
//   const [FooterText, setFooterText] = useState<string>("");
//   const [rows, setRows] = useState<RowData[]>([]);
//   const [previewImage, setPreviewImage] = useState<string | null>(null);
//   const [mediaBase64, setMediaBase64] = useState("");
//   const [showPicker, setShowPicker] = useState(false);
//   const [showDiscardDialog, setShowDiscardDialog] = useState(false);
//   const fileInputRef = useRef<HTMLInputElement>(null);

//   const [countryCodes, setCountryCodes] = useState<CountryCode[]>([]);
//   const [countryCodesLoading, setCountryCodesLoading] = useState(false);
//   const [hasFetchedCountryCodes, setHasFetchedCountryCodes] = useState(false);

//   const [languages, setLanguages] = useState<LanguageOption[]>([]);
//   const [languagesLoading, setLanguagesLoading] = useState(false);
//   const [hasFetchedLanguages, setHasFetchedLanguages] = useState(false);

//   const [fileName, setFileName] = useState<string>("");
//   const [fileType, setFileType] = useState<string>("");
//   const [fileLength, setFileLength] = useState<string>("");

//   const [validationErrors, setValidationErrors] = useState<ValidationErrors>({
//     language: '',
//     headerText: '',
//     bodyText: '',
//     footerText: '',
//     mediaFile: '',
//     headerContent: ''
//   });

//   const [buttonValidationErrors, setButtonValidationErrors] = useState<ButtonValidationErrors[]>([]);

//   const advUrl = useSelector((state: RootState) => state.authentication.apiURL);

//   const hasButtonValidationErrors = (): boolean => {
//     return buttonValidationErrors.some(errors =>
//       errors.buttonText || errors.websiteUrl || errors.phoneNumber || errors.countryCode || errors.copyOfferCode || errors.general
//     );
//   };

//   const getPhoneNumberButtonCount = (): number => {
//     return rows.filter(row => row.buttonType === 'PHONE_NUMBER').length;
//   };

//   const getUrlButtonCount = (): number =>
//     rows.filter(r => r.buttonType === 'URL').length;

//   const getCopyCodeButtonCount = (): number =>
//     rows.filter(r => r.buttonType === 'COPY_CODE').length;

//   const isFormValid = () => {
//     const urlsOk = getUrlButtonCount() <= 2;
//     const copiesOk = getCopyCodeButtonCount() <= 1;

//     return (
//       urlsOk &&
//       copiesOk &&
//       !validationErrors.language &&
//       !validationErrors.headerText &&
//       !validationErrors.bodyText &&
//       !validationErrors.footerText &&
//       !validationErrors.mediaFile &&
//       !validationErrors.headerContent &&
//       !hasButtonValidationErrors() &&
//       language.trim() !== '' &&
//       bodyText.trim() !== ''
//     );
//   };

//   const handleLanguageChange = (value: string) => {
//     setLanguage(value);
//     setValidationErrors(prev => ({
//       ...prev,
//       language: validateLanguage(value)
//     }));
//   };

//   const handleHeaderTextChange = (value: string) => {
//     setTextInput(value);
//     setValidationErrors(prev => ({
//       ...prev,
//       headerText: validateHeaderText(value),
//       headerContent: validateHeaderContent(headerType, value, !!selectedFile || !!mediaBase64)
//     }));
//   };

//   const handleBodyTextChange = (value: string) => {
//     setBodyText(value);
//     setValidationErrors(prev => ({
//       ...prev,
//       bodyText: validateBodyText(value)
//     }));
//   };

//   const handleFooterTextChange = (value: string) => {
//     setFooterText(value);
//     setValidationErrors(prev => ({
//       ...prev,
//       footerText: validateFooterText(value)
//     }));
//   };

//   const handleHeaderTypeChange = (value: string) => {
//     setHeaderType(value);
//     setTextInput("");
//     setSelectedFile(null);
//     setPreviewImage(null);
//     if (value === "none") setMediaBase64("");

//     setValidationErrors(prev => ({
//       ...prev,
//       headerText: '',
//       mediaFile: '',
//       headerContent: validateHeaderContent(value, "", false)
//     }));
//   };

//   useEffect(() => {
//     setButtonValidationErrors(prev => {
//       const newErrors = [...prev];
//       while (newErrors.length < rows.length) {
//         newErrors.push({
//           buttonText: '',
//           websiteUrl: '',
//           phoneNumber: '',
//           countryCode: '',
//           copyOfferCode: '',
//           general: ''
//         });
//       }
//       if (newErrors.length > rows.length) {
//         newErrors.splice(rows.length);
//       }
//       return newErrors;
//     });
//   }, [rows.length]);

//   useEffect(() => {
//     if (!initialContent) return;
//     if (
//       Array.isArray(initialContent?.components) &&
//       initialContent.components.some(
//         (c: any) =>
//           c.type === "BUTTONS" &&
//           Array.isArray(c.buttons) &&
//           c.buttons.some((btn: any) => btn.type === "PHONE_NUMBER")
//       ) &&
//       (!countryCodes || countryCodes.length === 0)
//     ) {
//       return;
//     }

//     const initialLanguage = initialContent.language || "en";
//     setLanguage(initialLanguage);

//     setValidationErrors(prev => ({
//       ...prev,
//       language: validateLanguage(initialLanguage)
//     }));

//     let components: any[] = [];
//     const componentSources = [
//       initialContent.components,
//       initialContent.template?.components,
//       initialContent.translated_template?.template?.components,
//       initialContent._originalTemplate?.components,
//       initialContent._debug_original?.translated_template?.template?.components,
//     ];
//     for (const source of componentSources) {
//       if (Array.isArray(source)) {
//         components = source;
//         break;
//       }
//     }

//     const headerComp = components.find((c: any) => c.type === "HEADER");
//     if (headerComp) {
//       const format = headerComp.format?.toLowerCase() || "none";
//       setHeaderType(format);

//       if (format === "text") {
//         const headerText = headerComp.text || "";
//         setTextInput(headerText);
//         setValidationErrors(prev => ({
//           ...prev,
//           headerText: validateHeaderText(headerText),
//           headerContent: validateHeaderContent(format, headerText, false),
//           mediaFile: ''
//         }));
//         setMediaBase64("");
//         setPreviewImage(null);
//         setFileName("");
//         setFileType("");
//         setFileLength("");
//       } else if (["image", "video", "document"].includes(format)) {
//         let mediaBase64Value = "";
//         let fileNameValue = "";
//         let fileTypeValue = "";
//         let fileLengthValue = "";

//         const mediaConfig = extractMediaConfig(initialContent);

//         if (mediaConfig && mediaConfig.binary_data) {
//           fileNameValue = mediaConfig.file_name || `media.${format}`;
//           fileTypeValue = mediaConfig.file_type || (
//             format === "image" ? "image/jpeg" :
//               format === "video" ? "video/mp4" :
//                 format === "document" ? "application/pdf" : ""
//           );
//           fileLengthValue = mediaConfig.file_length || "";

//           const binaryData = mediaConfig.binary_data;
//           if (binaryData) {
//             if (binaryData.startsWith("data:")) {
//               mediaBase64Value = binaryData;
//             } else {
//               const cleanBase64 = binaryData.replace(/^data:[^,]+,/, "");
//               mediaBase64Value = `data:${fileTypeValue};base64,${cleanBase64}`;
//             }
//           }
//         } else if (initialContent.Base64 && initialContent.Base64.length > 0) {
//           mediaBase64Value = initialContent.Base64;
//           fileTypeValue = format === "image" ? "image/jpeg" :
//             format === "video" ? "video/mp4" :
//               format === "document" ? "application/pdf" : "";
//           fileNameValue = `media.${format}`;
//         }

//         const hasMedia = !!mediaBase64Value;
//         setMediaBase64(mediaBase64Value);
//         setPreviewImage(mediaBase64Value);
//         setFileName(fileNameValue);
//         setFileType(fileTypeValue);
//         setFileLength(fileLengthValue);
//         setTextInput("");
//         setValidationErrors(prev => ({
//           ...prev,
//           headerText: '',
//           headerContent: validateHeaderContent(format, "", hasMedia),
//           mediaFile: ''
//         }));
//       } else {
//         setMediaBase64("");
//         setPreviewImage(null);
//         setTextInput("");
//         setFileName("");
//         setFileType("");
//         setFileLength("");
//         setValidationErrors(prev => ({
//           ...prev,
//           headerText: '',
//           headerContent: '',
//           mediaFile: ''
//         }));
//       }
//     } else {
//       setHeaderType("none");
//       setTextInput("");
//       setMediaBase64("");
//       setPreviewImage(null);
//       setFileName("");
//       setFileType("");
//       setFileLength("");
//       setValidationErrors(prev => ({
//         ...prev,
//         headerText: '',
//         headerContent: '',
//         mediaFile: ''
//       }));
//     }

//     const bodyComp = components.find((c: any) => c.type === "BODY");
//     const initialBodyText = bodyComp?.text || "";
//     setBodyText(initialBodyText);
//     setValidationErrors(prev => ({
//       ...prev,
//       bodyText: validateBodyText(initialBodyText)
//     }));

//     const footerComp = components.find((c: any) => c.type === "FOOTER");
//     const initialFooterText = footerComp?.text || "";
//     setFooterText(initialFooterText);
//     setValidationErrors(prev => ({
//       ...prev,
//       footerText: validateFooterText(initialFooterText)
//     }));

//     const btnComp = components.find((c: any) => c.type === "BUTTONS");
//     if (btnComp && Array.isArray(btnComp.buttons)) {
//       const buttonRows = btnComp.buttons.map((btn: any) => {
//         const baseRow = {
//           buttonText: "",
//           buttonTypeDropdown: "",
//           websiteUrl: "",
//           countryCode: "",
//           callPhoneNumber: "",
//           copyOfferCode: "",
//           qrResponse: "",
//           qrOptOut: false,
//         };

//         if (btn.type === "URL") {
//           return {
//             ...baseRow,
//             buttonType: "URL",
//             buttonText: btn.text || "",
//             websiteUrl: btn.url || "",
//           };
//         } else if (btn.type === "PHONE_NUMBER") {
//           const phoneNumber = btn.phone_number || "";
//           let foundCode = "";
//           let numberPart = phoneNumber;
//           if (countryCodes && countryCodes.length > 0 && phoneNumber) {
//             const sortedCodes = countryCodes.map(c => c.value).sort((a, b) => b.length - a.length);
//             for (const code of sortedCodes) {
//               if (phoneNumber.startsWith(code)) {
//                 foundCode = code;
//                 numberPart = phoneNumber.substring(code.length);
//                 break;
//               }
//             }
//           }
//           return {
//             ...baseRow,
//             buttonType: "PHONE_NUMBER",
//             buttonText: btn.text || "",
//             countryCode: foundCode,
//             callPhoneNumber: numberPart,
//           };
//         } else if (btn.type === "COPY_CODE") {
//           return {
//             ...baseRow,
//             buttonType: "COPY_CODE",
//             buttonText: "Copy",
//             copyOfferCode: btn.example || "",
//           };
//         } else if (btn.type === "QUICK_REPLY") {
//           const isActuallyCopyCode = btn.text === "Copy";
//           if (isActuallyCopyCode) {
//             let offerCode = "";
//             const originalTemplate = initialContent?.template || initialContent;
//             if (originalTemplate?.components) {
//               const origBtnComp = originalTemplate.components.find((c: any) => c.type === "BUTTONS");
//               if (origBtnComp?.buttons) {
//                 const copyBtn = origBtnComp.buttons.find((b: any) => b.type === "COPY_CODE");
//                 if (copyBtn) {
//                   offerCode = copyBtn.example || "";
//                 }
//               }
//             }
//             return {
//               ...baseRow,
//               buttonType: "COPY_CODE",
//               buttonText: "Copy",
//               copyOfferCode: offerCode,
//               qrResponse: "",
//               qrOptOut: false,
//             };
//           } else {
//             const qrData = Array.isArray(initialContent?.qr)
//               ? initialContent.qr.find((q: any) => q.label === btn.text)
//               : null;

//             return {
//               ...baseRow,
//               buttonType: "QUICK_REPLY",
//               buttonText: btn.text || "",
//               qrResponse: qrData?.response || "",
//               qrOptOut: qrData?.opt_out ?? false,
//             };
//           }
//         }
//         return baseRow;
//       });
//       setRows(buttonRows);
//     } else {
//       setRows([]);
//     }

//     setSelectedFile(null);
//   }, [initialContent, countryCodes]);

//   useEffect(() => {
//     if (!hasFetchedCountryCodes && !countryCodesLoading) {
//       fetchCountryCodes();
//     }
//     // eslint-disable-next-line
//   }, []);

//   useEffect(() => {
//     if (!hasFetchedLanguages && !languagesLoading) {
//       fetchLanguages();
//     }
//   }, []);

//   const fetchCountryCodes = async () => {
//     setCountryCodesLoading(true);
//     try {
//       const response = await axios.get(`${advUrl}/GetAllCountryCodes`);
//       if (response.data.status === "Success") {
//         setCountryCodes(response.data.country_codes);
//         setHasFetchedCountryCodes(true);
//       } else {
//         setCountryCodes([]);
//         toast({
//           title: "Error",
//           description: "Unable to fetch country codes.",
//         });
//       }
//     } catch (error: any) {
//       setCountryCodes([]);
//       toast({
//         title: "Error",
//         description: "Error fetching country codes.",
//       });
//     } finally {
//       setCountryCodesLoading(false);
//     }
//   };

//   const fetchLanguages = async () => {
//     setLanguagesLoading(true);
//     try {
//       const response = await axios.get(`${advUrl}/GetLanguages`);
//       if (response.data.status === "Success") {
//         setLanguages(response.data.languages);
//         setHasFetchedLanguages(true);
//       } else {
//         setLanguages([]);
//         toast({
//           title: "Error",
//           description: "Unable to fetch languages.",
//         });
//       }
//     } catch (error) {
//       setLanguages([]);
//       toast({
//         title: "Error",
//         description: "Error fetching languages.",
//       });
//     } finally {
//       setLanguagesLoading(false);
//     }
//   };

//   const maxLength = 60;

//   const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (file) {
//       const mediaFileError = validateMediaFile(file);

//       if (mediaFileError) {
//         setValidationErrors(prev => ({
//           ...prev,
//           mediaFile: mediaFileError,
//           headerContent: validateHeaderContent(headerType, textInput, false)
//         }));
//         setSelectedFile(null);
//         setFileName('');
//         setFileType('');
//         setFileLength('');
//         setPreviewImage(null);
//         setMediaBase64('');
//         if (fileInputRef.current) fileInputRef.current.value = '';
//         return;
//       }

//       setSelectedFile(file);
//       setFileName(file.name);
//       setFileType(file.type);
//       setFileLength(file.size.toString());

//       if (file.type.startsWith("image/")) {
//         const reader = new FileReader();
//         reader.onload = (e) => setPreviewImage(e.target?.result as string);
//         reader.readAsDataURL(file);
//       }

//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const base64 = (e.target?.result as string)?.split(",")[1] || "";
//         setMediaBase64(base64);
//       };
//       reader.readAsDataURL(file);

//       setValidationErrors(prev => ({
//         ...prev,
//         mediaFile: '',
//         headerContent: validateHeaderContent(headerType, textInput, true)
//       }));
//     }
//   };

//   const onEmojiClick = (emojiObject: any) => {
//     setBodyText((prev) => prev + emojiObject.emoji);
//     setShowPicker(false);
//   };

//   const insertFormattingTags = (startTag: string, endTag: string) => {
//     const textarea = document.querySelector('textarea[name="bodyText"]') as HTMLTextAreaElement;
//     if (!textarea) return;
//     const start = textarea.selectionStart;
//     const end = textarea.selectionEnd;
//     const selectedText = textarea.value.substring(start, end);
//     const replacement = startTag + selectedText + endTag;
//     const newValue = textarea.value.substring(0, start) + replacement + textarea.value.substring(end);
//     handleBodyTextChange(newValue);
//     setTimeout(() => {
//       textarea.focus();
//       textarea.setSelectionRange(start + startTag.length, start + startTag.length + selectedText.length);
//     }, 0);
//   };

//   const addButtonRow = () => {
//     if (rows.length < 3) {
//       setRows([...rows, {
//         buttonType: "",
//         buttonText: "",
//         buttonTypeDropdown: "static",
//         websiteUrl: "",
//         countryCode: "",
//         callPhoneNumber: "",
//         copyOfferCode: "",
//         qrResponse: "",
//         qrOptOut: false,
//       }]);
//     }
//   };

//   const removeButtonRow = (index: number) => {
//     setRows(rows.filter((_, i) => i !== index));
//     setButtonValidationErrors(prev => prev.filter((_, i) => i !== index));
//   };

//   debugger;
//   const updateButtonRow = (index: number, field: keyof RowData, value: string | boolean) => {
//     if (field === 'buttonType' && value === 'PHONE_NUMBER') {
//       const currentPhoneCount = getPhoneNumberButtonCount();
//       if (currentPhoneCount >= 1 && rows[index].buttonType !== 'PHONE_NUMBER') {
//         setButtonValidationErrors(prev => {
//           const next = [...prev];
//           next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
//           next[index].general = 'Only one phone number button is allowed per template';
//           return next;
//         });
//         return;
//       }
//     }

//     if (field === 'buttonType' && value === 'URL') {
//       const currentUrlCount = getUrlButtonCount();
//       if (currentUrlCount >= 2 && rows[index].buttonType !== 'URL') {
//         setButtonValidationErrors(prev => {
//           const next = [...prev];
//           next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
//           next[index].general = 'Only two website buttons are allowed per template';
//           return next;
//         });
//         return;
//       }
//     }

//     if (field === 'buttonType' && value === 'COPY_CODE') {
//       const currentCopyCount = getCopyCodeButtonCount();
//       if (currentCopyCount >= 1 && rows[index].buttonType !== 'COPY_CODE') {
//         setButtonValidationErrors(prev => {
//           const next = [...prev];
//           next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
//           next[index].general = 'Only one copy offer code button is allowed per template';
//           return next;
//         });
//         return;
//       }
//     }

//     if (field === 'buttonType' && value === 'QUICK_REPLY') {
//       const currentQRCount = rows.filter(r => r.buttonType === 'QUICK_REPLY').length;
//       if (currentQRCount >= 3 && rows[index].buttonType !== 'QUICK_REPLY') {
//         setButtonValidationErrors(prev => {
//           const next = [...prev];
//           next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
//           next[index].general = 'Only three quick reply button is allowed per template';
//           return next;
//         });
//         return;
//       }
//     }

//     const nextRows = rows.map((row, i) => {
//       if (i !== index) return row;
//       const updated = { ...row, [field]: value };
//       if (field === 'buttonType' && value === 'COPY_CODE') updated.buttonText = 'Copy';
//       return updated;
//     });
//     setRows(nextRows);

//     setButtonValidationErrors(prev => {
//       const newErrors = [...prev];
//       newErrors[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };

//       if (field === 'buttonType') {
//         newErrors[index] = { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
//         if (value === 'PHONE_NUMBER') {
//           newErrors[index].countryCode = validateCountryCode(nextRows[index].countryCode, 'PHONE_NUMBER');
//           newErrors[index].phoneNumber = validatePhoneNumber(nextRows[index].callPhoneNumber);
//           newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, 'PHONE_NUMBER');
//         }
//         if (value === 'URL') {
//           newErrors[index].websiteUrl = validateWebsiteUrl(nextRows[index].websiteUrl);
//           newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, 'URL');
//         }
//         if (value === 'COPY_CODE') {
//           newErrors[index].copyOfferCode = validateCopyOfferCode(nextRows[index].copyOfferCode);
//           newErrors[index].buttonText = '';
//         }
//       } else {
//         switch (field) {
//           case 'buttonText': {
//             // ✅ Rule 1: Check for duplicate QUICK_REPLY button text
//             const currentButtonType = nextRows[index].buttonType;
//             if (currentButtonType === 'QUICK_REPLY') {
//               const currentText = (nextRows[index].buttonText ?? '').trim().toLowerCase();
//               const isDuplicate = nextRows.some(
//                 (r, i) =>
//                   i !== index &&
//                   r.buttonType === 'QUICK_REPLY' &&
//                   (r.buttonText ?? '').trim().toLowerCase() === currentText &&
//                   currentText !== ''
//               );

//               if (isDuplicate) {
//                 newErrors[index].buttonText = 'Quick reply button text must be unique.';
//                 // Also flag the other button(s) that share the same text
//                 nextRows.forEach((r, i) => {
//                   if (
//                     i !== index &&
//                     r.buttonType === 'QUICK_REPLY' &&
//                     (r.buttonText ?? '').trim().toLowerCase() === currentText
//                   ) {
//                     newErrors[i] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
//                     newErrors[i].buttonText = 'Quick reply button text must be unique.';
//                   }
//                 });
//               } else {
//                 // No duplicate — run standard button text validation
//                 newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, currentButtonType);
//                 // Also clear duplicate error on other QR buttons that may have been flagged
//                 nextRows.forEach((r, i) => {
//                   if (i !== index && r.buttonType === 'QUICK_REPLY') {
//                     // Re-check if that button is still a duplicate with anyone else
//                     const otherText = (r.buttonText ?? '').trim().toLowerCase();
//                     const stillDuplicate = nextRows.some(
//                       (r2, i2) =>
//                         i2 !== i &&
//                         r2.buttonType === 'QUICK_REPLY' &&
//                         (r2.buttonText ?? '').trim().toLowerCase() === otherText &&
//                         otherText !== ''
//                     );
//                     if (!stillDuplicate && newErrors[i]?.buttonText === 'Quick reply button text must be unique.') {
//                       newErrors[i].buttonText = '';
//                     }
//                   }
//                 });
//               }
//             } else {
//               newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, currentButtonType);
//             }
//             break;
//           }
//           case 'websiteUrl':
//             newErrors[index].websiteUrl = validateWebsiteUrl(nextRows[index].websiteUrl);
//             break;
//           case 'countryCode':
//             newErrors[index].countryCode = validateCountryCode(nextRows[index].countryCode, nextRows[index].buttonType);
//             break;
//           case 'callPhoneNumber':
//             newErrors[index].phoneNumber = validatePhoneNumber(nextRows[index].callPhoneNumber);
//             newErrors[index].countryCode = validateCountryCode(nextRows[index].countryCode, nextRows[index].buttonType);
//             break;
//           case 'copyOfferCode':
//             newErrors[index].copyOfferCode = validateCopyOfferCode(nextRows[index].copyOfferCode);
//             break;
//         }
//       }
//       return newErrors;
//     });
//   };

//   const renderFormattedText = (text: string) =>
//     text
//       .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
//       .replace(/_([^_]+)_/g, '<em>$1</em>')
//       .replace(/~([^~]+)~/g, '<s>$1</s>')
//       .replace(/`([^`]+)`/g, '<code style="background: #f1f1f1; padding: 2px 4px; border-radius: 3px;">$1</code>')
//       .replace(/\{\{(\d+)\}\}/g, '<span style="background: #e3f2fd; padding: 2px 4px; border-radius: 3px; color: #1976d2;">{{$1}}</span>');

//   const noContentSelected =
//     !textInput.trim() && !previewImage && !selectedFile && !mediaBase64 &&
//     !bodyText.trim() && !FooterText.trim() &&
//     rows.filter(row => row.buttonText.trim()).length === 0;

//   const handleSubmitWhatsApp = () => {
//     if (!isFormValid()) {
//       toast({
//         title: "Validation Error",
//         description: "Please fix all validation errors before saving.",
//       });
//       return;
//     }

//     const newName =
//       initialContent?.name ||
//       initialContent?.template?.name ||
//       initialContent?.translated_template?.template?.name ||
//       "whatsapp_template";

//     let media_config = {
//       file_name: "",
//       file_type: "",
//       binary_data: "",
//       file_length: "",
//     };

//     if (
//       (headerType === "image" || headerType === "video" || headerType === "document") &&
//       (mediaBase64 || selectedFile)
//     ) {
//       let fileTypeToUse = fileType;
//       let fileNameToUse = fileName;
//       let fileLengthToUse = fileLength;

//       if (selectedFile) {
//         fileTypeToUse = selectedFile.type;
//         fileNameToUse = selectedFile.name;
//         fileLengthToUse = selectedFile.size ? selectedFile.size.toString() : "";
//       }
//       let base64Data = mediaBase64;
//       if (mediaBase64 && !mediaBase64.startsWith("data:")) {
//         base64Data = `data:${fileTypeToUse};base64,${mediaBase64}`;
//       }

//       media_config = {
//         file_name: fileNameToUse,
//         file_type: fileTypeToUse,
//         binary_data: base64Data,
//         file_length: fileLengthToUse,
//       };
//     }

//     if (!(headerType === "image" || headerType === "video" || headerType === "document")) {
//       media_config = {
//         file_name: "",
//         file_type: "",
//         binary_data: "",
//         file_length: "",
//       };
//     }

//     const phone_id = initialContent?.phone_id || "";
//     const channel_config_id = initialContent?.channel_config_id || "";
//     const template_id = initialContent?.template_id || "";

//     debugger;
//     const qrButtons = rows
//       .filter(row => row.buttonType === "QUICK_REPLY" && row.buttonText.trim())
//       .map(row => ({
//         label: row.buttonText,
//         opt_out: row.qrOptOut ?? false,
//         response: row.qrResponse
//       }));

//     const template: any = {
//       template_id,
//       name: newName,
//       language,
//       category: "MARKETING",
//       Base64: mediaBase64 || "",
//       components: [],
//       media_config,
//       phone_id,
//       channel_config_id,
//     };

//     if (headerType && headerType !== "none") {
//       const headerObj: any = {
//         type: "HEADER",
//         format: headerType?.toUpperCase()
//       };
//       if (headerType === "text") headerObj.text = textInput;
//       template.components.push(headerObj);
//     }
//     template.components.push({ type: "BODY", text: bodyText });
//     if (FooterText) template.components.push({ type: "FOOTER", text: FooterText });

//     const buttons = rows.filter(row =>
//       row.buttonText.trim() ||
//       (row.buttonType === 'COPY_CODE' && row.copyOfferCode.trim())
//     ).map(row => {
//       if (row.buttonType === "URL") {
//         const href = normalizeUrl(row.websiteUrl);
//         return { type: "URL", text: row.buttonText, url: href };
//       } else if (row.buttonType === "PHONE_NUMBER") {
//         return { type: "PHONE_NUMBER", text: row.buttonText, phone_number: row.countryCode + row.callPhoneNumber };
//       } else if (["COPY_CODE"].includes(row.buttonType)) {
//         return { type: "COPY_CODE", example: row.copyOfferCode };
//       } else if (row.buttonType === "QUICK_REPLY") {
//         return { type: "QUICK_REPLY", text: row.buttonText };
//       }
//       return {};
//     });

//     if (buttons.length > 0)
//       template.components.push({ type: "BUTTONS", buttons });

//     const toSave = {
//       ...template,
//       phone_id,
//       channel_config_id,
//       template_id,
//       qr: qrButtons
//     };
//     onSave(toSave);
//     onClose();
//   };

//   const getBase64Src = (type: string) => {
//     if (!mediaBase64) return null;
//     if (mediaBase64.startsWith("data:")) return mediaBase64;
//     if (type === "image") return `data:image/jpeg;base64,${mediaBase64}`;
//     if (type === "video") return `data:video/mp4;base64,${mediaBase64}`;
//     if (type === "document") return `data:application/pdf;base64,${mediaBase64}`;
//     return "";
//   };

//   console.log("[QR CHECK - CreateContentWhatsappCard initialContent]", JSON.stringify(initialContent?.qr));

//   return (
//     <>
//       <div className="flex flex-col md:flex-row gap-6 mb-6 mt-4">
//         <div className="space-y-6 w-full md:w-3/5">
//           <Card className="border p-4 rounded-lg text-left">
//             <h2 className="text-base font-semibold mb-2">Content</h2>
//             <div className="flex-shrink-0">
//               <Label htmlFor="language">Language</Label>
//               <Select value={language} onValueChange={handleLanguageChange} disabled={languagesLoading}>
//                 <SelectTrigger className={`text-[#020617] w-1/2 mt-2 ${validationErrors.language ? 'border-red-500' : ''}`}>
//                   <SelectValue className="text-[#020617]" placeholder={languagesLoading ? "Loading..." : "Select Language"} />
//                 </SelectTrigger>
//                 <SelectContent className="h-48">
//                   {languages.map((option: LanguageOption) => (
//                     <SelectItem key={option.value} value={option.value} className="cursor-pointer">
//                       {option.label}
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>
//               {validationErrors.language && (
//                 <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.language}</p>
//               )}
//             </div>
//             <div className="space-y-4 mt-4">
//               <div>
//                 <Label>Header</Label>
//                 <div
//                   style={{
//                     background: "#F0F4F8",
//                     color: "#64748B",
//                     padding: "2px 10px",
//                     borderRadius: "9999px",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     height: "20px",
//                     marginLeft: "8px",
//                     fontSize: "14px",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Optional
//                 </div>
//                 <Select value={headerType} onValueChange={handleHeaderTypeChange}>
//                   <SelectTrigger className="w-full text-[#020617] mt-2">
//                     <SelectValue placeholder="Select Header Type" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectItem value="none">None</SelectItem>
//                     <SelectItem value="text">Text</SelectItem>
//                     <SelectItem value="image">Image</SelectItem>
//                     <SelectItem value="video">Video</SelectItem>
//                     <SelectItem value="document">Document</SelectItem>
//                   </SelectContent>
//                 </Select>
//                 {validationErrors.headerContent && (
//                   <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.headerContent}</p>
//                 )}
//               </div>
//               {headerType === "text" && (
//                 <div>
//                   <div className="flex justify-between">
//                     <Label>Header Text</Label>
//                     <div className="text-xs text-gray-500 mt-0">{textInput.length}/{maxLength}</div>
//                   </div>
//                   <Input
//                     value={textInput}
//                     onChange={(e) => handleHeaderTextChange(e.target.value)}
//                     placeholder="Enter header text"
//                     className={`mt-2 text-[#020617] ${validationErrors.headerText ? 'border-red-500' : ''}`}
//                     maxLength={60}
//                     disabled={!!mediaBase64}
//                   />
//                   {validationErrors.headerText && (
//                     <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.headerText}</p>
//                   )}
//                 </div>
//               )}
//               {["image", "video", "document"].includes(headerType) && (
//                 <div>
//                   <Label>Upload {headerType}</Label>
//                   <div className="mt-2">
//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       onChange={handleFileChange}
//                       accept={
//                         headerType === "image"
//                           ? "image/*"
//                           : headerType === "video"
//                             ? "video/*"
//                             : ".pdf,.doc,.docx"
//                       }
//                       className="hidden"
//                       disabled={!!mediaBase64}
//                     />
//                     <Button
//                       type="button"
//                       variant="outline"
//                       onClick={() => fileInputRef.current?.click()}
//                       className="w-full border-dashed border-2 h-20 text-[#020617]"
//                     >
//                       {selectedFile ? (
//                         <div className="text-center">
//                           <div className="font-medium">{selectedFile.name}</div>
//                           <div className="text-sm text-gray-500">
//                             {(selectedFile.size / 1024).toFixed(1)} KB
//                           </div>
//                         </div>
//                       ) : (
//                         <div className="text-center">
//                           <PlusIcon className="mx-auto h-6 w-6 mb-2" />
//                           {`Click to upload ${headerType}`}
//                         </div>
//                       )}
//                     </Button>
//                     {validationErrors.mediaFile && (
//                       <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.mediaFile}</p>
//                     )}
//                     {(selectedFile || mediaBase64) && (
//                       <div className="flex justify-end">
//                         <Button
//                           type="button"
//                           variant="ghost"
//                           onClick={() => {
//                             setSelectedFile(null);
//                             setPreviewImage(null);
//                             setMediaBase64('');
//                             setFileName('');
//                             setFileType('');
//                             setFileLength('');
//                             if (fileInputRef.current) fileInputRef.current.value = '';
//                             setValidationErrors(prev => ({
//                               ...prev,
//                               mediaFile: '',
//                               headerContent: validateHeaderContent(headerType, textInput, false)
//                             }));
//                           }}
//                           className="text-red-500 mt-1 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
//                         >
//                           <FaTrash className="mr-2" />
//                           Remove file
//                         </Button>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//               {/* Body Text */}
//               <div>
//                 <div className="flex justify-between">
//                   <Label>Body</Label>
//                   <div className="text-xs text-gray-500 mb-1 flex justify-end">{bodyText.length}/1024</div>
//                 </div>
//                 <div className="relative mt-2">
//                   <Textarea
//                     name="bodyText"
//                     className={`w-full border rounded p-2 text-[#020617] pr-14 min-h-[120px] max-h-[120px] overflow-y-auto resize-none ${validationErrors.bodyText ? 'border-red-500' : ''}`}
//                     maxLength={1024}
//                     value={bodyText}
//                     placeholder="Hello"
//                     onChange={(e) => handleBodyTextChange(e.target.value)}
//                   />
//                   <div className="absolute mt-2 right-2 flex gap-2">
//                     <Smile
//                       className="w-4 h-4 cursor-pointer text-gray-600 mb-4 hover:text-gray-800"
//                       onClick={() => setShowPicker(!showPicker)}
//                     />
//                     <FontBoldIcon
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("*", "*")}
//                     />
//                     <FontItalicIcon
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("_", "_")}
//                     />
//                     <Strikethrough
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("~", "~")}
//                     />
//                     <CodeIcon
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("`", "`")}
//                     />
//                   </div>
//                   {showPicker && (
//                     <div className="absolute top-full left-0 z-50 mt-2">
//                       <EmojiPicker onEmojiClick={onEmojiClick} />
//                     </div>
//                   )}
//                 </div>
//                 {validationErrors.bodyText && (
//                   <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.bodyText}</p>
//                 )}
//               </div>
//               {/* Footer */}
//               <div>
//                 <div className="flex justify-between mt-8">
//                   <div>
//                     <Label>Footer</Label>
//                     <div
//                       style={{
//                         background: "#F0F4F8",
//                         color: "#64748B",
//                         padding: "2px 10px",
//                         borderRadius: "9999px",
//                         display: "inline-flex",
//                         alignItems: "center",
//                         height: "20px",
//                         marginLeft: "8px",
//                         fontSize: "14px",
//                         fontWeight: 600,
//                       }}
//                     >
//                       Optional
//                     </div>
//                   </div>
//                   <div className="text-xs text-gray-500 mt-0 flex justify-end">{FooterText.length}/60</div>
//                 </div>
//                 <Input
//                   value={FooterText}
//                   onChange={(e) => handleFooterTextChange(e.target.value)}
//                   placeholder="Enter footer text"
//                   className={`mt-2 text-[#020617] ${validationErrors.footerText ? 'border-red-500' : ''}`}
//                   maxLength={60}
//                 />
//                 {validationErrors.footerText && (
//                   <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.footerText}</p>
//                 )}
//               </div>
//               {/* Buttons Section */}
//               <div>
//                 <Label className="text-base font-semibold">Buttons</Label>
//                 <div
//                   style={{
//                     background: "#F0F4F8",
//                     color: "#64748B",
//                     padding: "2px 10px",
//                     borderRadius: "9999px",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     height: "20px",
//                     marginLeft: "8px",
//                     fontSize: "14px",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Optional
//                 </div>
//                 <div className="space-y-3 mt-2">
//                   {rows.map((row, index) => {

//                     // ✅ Rule 2: Disable optOut checkbox on this row if any OTHER
//                     // Quick Reply row already has qrOptOut checked
//                     const anyOtherOptOutChecked = rows.some(
//                       (r, i) =>
//                         i !== index &&
//                         r.buttonType === 'QUICK_REPLY' &&
//                         r.qrOptOut === true
//                     );

//                     return (
//                       <div key={index} className="border rounded-lg p-4 bg-gray-50">
//                         <div className="flex flex-col space-y-3">
//                           {/* General button error */}
//                           {buttonValidationErrors[index]?.general && (
//                             <p className="text-red-500 font-medium text-xs italic">{buttonValidationErrors[index].general}</p>
//                           )}

//                           {/* Button Type and Text */}
//                           <div className="flex flex-col md:flex-row gap-3">
//                             <div className="flex-1">
//                               <Label className="text-sm">Action type</Label>
//                               <Select
//                                 value={row.buttonType}
//                                 onValueChange={(value) => updateButtonRow(index, "buttonType", value)}
//                               >
//                                 <SelectTrigger className="text-[#020617] mt-1">
//                                   <SelectValue placeholder="Select action type" />
//                                 </SelectTrigger>
//                                 <SelectContent>
//                                   <SelectItem value="URL">View Website</SelectItem>
//                                   <SelectItem value="PHONE_NUMBER">Call Phone Number</SelectItem>
//                                   <SelectItem value="COPY_CODE">Copy Offer Code</SelectItem>
//                                   <SelectItem value="QUICK_REPLY">Quick Reply</SelectItem>
//                                 </SelectContent>
//                               </Select>
//                             </div>
//                             <div className="flex-1">
//                               <div className="flex justify-between">
//                                 <Label className="text-sm">Button text</Label>
//                                 {(row.buttonType === "URL" || row.buttonType === "PHONE_NUMBER" || row.buttonType === "COPY_CODE") && (
//                                   <div className="text-xs text-gray-500 mt-0">
//                                     {row.buttonText.length}/25
//                                   </div>
//                                 )}
//                               </div>
//                               <Input
//                                 className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.buttonText ? 'border-red-500' : ''}`}
//                                 placeholder="Button text"
//                                 value={row.buttonType === "COPY_CODE" ? "Copy" : row.buttonText}
//                                 onChange={(e) => updateButtonRow(index, "buttonText", e.target.value)}
//                                 maxLength={25}
//                                 disabled={row.buttonType === "COPY_CODE"}
//                               />
//                               {buttonValidationErrors[index]?.buttonText && (
//                                 <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].buttonText}</p>
//                               )}
//                             </div>
//                           </div>

//                           {row.buttonType === "URL" && (
//                             <div>
//                               <Label className="text-sm">Website URL</Label>
//                               <Input
//                                 className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.websiteUrl ? 'border-red-500' : ''}`}
//                                 placeholder="https://example.com"
//                                 value={row.websiteUrl}
//                                 onChange={(e) => updateButtonRow(index, "websiteUrl", e.target.value)}
//                                 onBlur={(e) => {
//                                   const v = e.target.value.trim();
//                                   if (/^www\./i.test(v)) {
//                                     updateButtonRow(index, "websiteUrl", `https://${v}`);
//                                   }
//                                 }}
//                               />
//                               {buttonValidationErrors[index]?.websiteUrl && (
//                                 <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].websiteUrl}</p>
//                               )}
//                             </div>
//                           )}

//                           {row.buttonType === "PHONE_NUMBER" && (
//                             <div className="flex gap-3">
//                               <div className="w-36">
//                                 <Label className="text-sm">Country Code</Label>
//                                 <Select
//                                   value={row.countryCode}
//                                   onValueChange={(value) => updateButtonRow(index, "countryCode", value)}
//                                 >
//                                   <SelectTrigger className="text-[#020617] mt-1">
//                                     <SelectValue placeholder="Select Code" />
//                                   </SelectTrigger>
//                                   <SelectContent className="h-48">
//                                     {countryCodes.map((option: CountryCode) => (
//                                       <SelectItem key={option.value} value={option.value} className="cursor-pointer">
//                                         {option.label}
//                                       </SelectItem>
//                                     ))}
//                                   </SelectContent>
//                                 </Select>
//                                 {buttonValidationErrors[index]?.countryCode && (
//                                   <p className="text-red-500 font-medium text-xs mt-1 italic">
//                                     {buttonValidationErrors[index].countryCode}
//                                   </p>
//                                 )}
//                               </div>
//                               <div className="flex-1">
//                                 <Label className="text-sm">Phone Number</Label>
//                                 <Input
//                                   className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.phoneNumber ? 'border-red-500' : ''}`}
//                                   placeholder="Phone number"
//                                   value={row.callPhoneNumber}
//                                   onChange={(e) => updateButtonRow(index, "callPhoneNumber", e.target.value)}
//                                 />
//                                 {buttonValidationErrors[index]?.phoneNumber && (
//                                   <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].phoneNumber}</p>
//                                 )}
//                               </div>
//                             </div>
//                           )}

//                           {row.buttonType === "COPY_CODE" && (
//                             <div>
//                               <div className="flex justify-between">
//                                 <Label className="text-sm">Offer Code</Label>
//                                 <div className="text-xs text-gray-500 mt-0">
//                                   {row.copyOfferCode.length}/15
//                                 </div>
//                               </div>
//                               <Input
//                                 className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.copyOfferCode ? 'border-red-500' : ''}`}
//                                 placeholder="Offer code"
//                                 value={row.copyOfferCode}
//                                 onChange={(e) => updateButtonRow(index, "copyOfferCode", e.target.value)}
//                               />
//                               {buttonValidationErrors[index]?.copyOfferCode && (
//                                 <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].copyOfferCode}</p>
//                               )}
//                             </div>
//                           )}

//                           {row.buttonType === "QUICK_REPLY" && (
//                             <div>
//                               <div className="flex justify-between items-center mb-1">
//                                 <Label className="text-sm">Quick Reply Responses</Label>
//                                 {/* ✅ Rule 2: Disable optOut if any other QR row has qrOptOut checked */}
//                                 <div className={`flex items-center gap-2 ${anyOtherOptOutChecked ? "cursor-not-allowed" : ""}`}>
//                                   <input
//                                     type="checkbox"
//                                     id={`optout-${index}`}
//                                     checked={row.qrOptOut}
//                                     onChange={(e) =>
//                                       updateButtonRow(index, "qrOptOut" as keyof RowData, e.target.checked as any)
//                                     }
//                                     className={`w-4 h-4 accent-blue-600 ${anyOtherOptOutChecked ? "pointer-events-none opacity-50" : ""}`}
//                                     disabled={anyOtherOptOutChecked}
//                                   />
//                                   <Label
//                                     htmlFor={`optout-${index}`}
//                                     className={`text-sm ${anyOtherOptOutChecked ? "cursor-not-allowed text-gray-400" : "cursor-pointer"}`}
//                                   >
//                                     OptOut
//                                   </Label>
//                                 </div>
//                               </div>
//                               <Textarea
//                                 className="text-[#020617] min-h-[80px] resize-none"
//                                 placeholder="Enter quick reply response..."
//                                 value={row.qrResponse}
//                                 onChange={(e) =>
//                                   updateButtonRow(index, "qrResponse" as keyof RowData, e.target.value)
//                                 }
//                               />
//                             </div>
//                           )}

//                           {/* Remove button */}
//                           <div className="flex justify-end">
//                             <Button
//                               variant="ghost"
//                               size="sm"
//                               onClick={() => removeButtonRow(index)}
//                               className="text-red-500 mt-0 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
//                             >
//                               <FaTrash className="w-3 h-4 mr-2" /> Delete Button
//                             </Button>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                   {rows.length < 3 && (
//                     <Button
//                       variant="outline"
//                       onClick={addButtonRow}
//                       className="w-full mt-2 text-[#3A85F7] border-[#3A85F7] hover:bg-blue-50"
//                     >
//                       <PlusIcon className="w-4 h-4 mr-2" />
//                       Add Button
//                     </Button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Card>
//         </div>
//         {/* Preview */}
//         <div className="w-full md:w-2/5 max-w-[500px] border rounded-lg p-4 max-h-[750px] flex flex-col overflow-hidden">
//           <h2 className="mb-2 mt-0 font-bold text-left">Content Preview</h2>
//           <div
//             className="rounded-2xl p-4 min-h-[350px] overflow-y-auto flex-1"
//             style={{
//               backgroundImage: `url(${Default_WhatsApp_background})`,
//               backgroundSize: 'cover',
//               backgroundPosition: 'center',
//               backgroundRepeat: 'no-repeat'
//             }}
//           >
//             {noContentSelected ? (
//               <div className="flex w-full h-full items-center justify-center">
//                 <div className="text-center">
//                   <div className="relative w-8 h-8 flex justify-center items-center">
//                     <div
//                       className="absolute rounded w-[3px] h-8 transform rotate-45"
//                       style={{ borderLeft: "3px solid #64748B" }}
//                     />
//                     <div
//                       className="absolute w-[3px] h-4 rounded transform rotate-45 translate-x-2 translate-y-2"
//                       style={{ borderLeft: "3px solid #64748B" }}
//                     />
//                   </div>
//                   <div className="mt-6">
//                     <p className="text-xl font-semibold">Mobile screen</p>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <>
//                 {headerType === "text" && textInput && (
//                   <div className="font-semibold mb-2 text-lg">{textInput}</div>
//                 )}
//                 {headerType === "image" && (
//                   <div className="mb-2">
//                     <img
//                       src={selectedFile ? previewImage || "" : getBase64Src("image") || ""}
//                       alt="Header"
//                       className="w-full h-40 object-cover rounded-lg"
//                     />
//                   </div>
//                 )}
//                 {headerType === "video" && (
//                   <div className="mb-2">
//                     {selectedFile ? (
//                       <video controls className="w-full h-40 object-cover rounded-lg" src={URL.createObjectURL(selectedFile)} />
//                     ) : mediaBase64 ? (
//                       <video controls className="w-full h-40 object-cover rounded-lg" src={getBase64Src("video") || ""} />
//                     ) : null}
//                   </div>
//                 )}
//                 {headerType === "document" && (
//                   <div className="mb-2">
//                     {selectedFile ? (
//                       <div className="p-3 bg-gray-100 rounded-lg flex items-center space-x-2">
//                         <FaFilePdf className="w-6 h-6 text-red-500" />
//                         <div>
//                           <div className="text-sm font-medium">{selectedFile.name}</div>
//                           <div className="text-xs text-gray-500">{(selectedFile.size / 1024).toFixed(1)} KB</div>
//                         </div>
//                       </div>
//                     ) : mediaBase64 ? (
//                       <embed src={getBase64Src("document") || ""} type="application/pdf" width="100%" height="200px" className="rounded-lg" />
//                     ) : null}
//                   </div>
//                 )}
//                 {bodyText && (
//                   <div
//                     className="mb-2 whitespace-pre-wrap break-words text-sm leading-relaxed"
//                     dangerouslySetInnerHTML={{ __html: renderFormattedText(bodyText) }}
//                   />
//                 )}
//                 {FooterText && (
//                   <div className="text-black font-semibold border-t pt-2 mt-3 text-[14px] flex justify-center">
//                     {FooterText}
//                   </div>
//                 )}
//                 {rows.filter(row =>
//                   row.buttonText.trim() ||
//                   (row.buttonType === 'COPY_CODE' && row.copyOfferCode.trim())
//                 ).length > 0 && (
//                   <div className="mt-3 space-y-2">
//                     {rows.filter(row =>
//                       row.buttonText.trim() ||
//                       (row.buttonType === 'COPY_CODE' && row.copyOfferCode.trim())
//                     ).map((button, index) => (
//                       <p
//                         key={index}
//                         className="font-serif text-blue-400 flex justify-center"
//                         style={{ fontSize: "14px" }}
//                       >
//                         {button.buttonType === 'COPY_CODE' ? 'Copy' : button.buttonText}
//                         <div className="border-t mt-2"></div>
//                       </p>
//                     ))}
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//       {/* Button Row */}
//       <div className="flex justify-end space-x-3 -mt-4 mr-0 h-[40px]">
//         <Dialog open={showDiscardDialog} onOpenChange={setShowDiscardDialog}>
//           <DialogTrigger asChild>
//             <Button
//               variant={"outline"}
//               className="w-[80px] border-red-500 text-red-500 hover:bg-red-500 hover:text-white mt-0"
//               onClick={() => setShowDiscardDialog(true)}
//             >
//               Discard
//             </Button>
//           </DialogTrigger>
//           <DialogContent className="sm:max-w-[425px]">
//             <DialogHeader>
//               <DialogDescription>
//                 Are you sure you want to discard this Template?
//               </DialogDescription>
//             </DialogHeader>
//             <DialogFooter>
//               <DialogClose asChild>
//                 <Button type="button" variant="outline" className="w-24">
//                   Cancel
//                 </Button>
//               </DialogClose>
//               <Button className="w-24" onClick={onClose}>
//                 OK
//               </Button>
//             </DialogFooter>
//           </DialogContent>
//         </Dialog>
//         <Button
//           className={`w-[100px] mt-0 ${isFormValid()
//             ? "bg-[#3A85F7] text-white hover:bg-blue-600"
//             : "bg-gray-300 text-gray-500 cursor-not-allowed"
//             }`}
//           onClick={handleSubmitWhatsApp}
//           disabled={!isFormValid()}
//         >
//           Save
//         </Button>
//       </div>
//     </>
//   );
// };

// export default CreateContentWhatsapp;



import React, { useState, useEffect, useRef, ChangeEvent } from "react";
import { Button } from "../../../../Components/ui/button";
import Default_WhatsApp_background from "../../../../Assets/Default_WhatsApp_background.jpeg";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../Components/ui/select";
import { Input } from "../../../../Components/ui/input";
import { Label } from "../../../../Components/ui/label";
import { Textarea } from "../../../../Components/ui/textarea";
import { FaTrash, FaFilePdf } from "react-icons/fa";
import { PlusIcon, FontBoldIcon, FontItalicIcon, CodeIcon } from "@radix-ui/react-icons";
import { Smile, Strikethrough } from "lucide-react";
import EmojiPicker from "emoji-picker-react";
import { Card } from "../../../../Components/ui/card";
import emojiRegex from 'emoji-regex';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "../../../../Components/ui/dialog";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import { toast } from "../../../../Components/ui/use-toast";

interface CountryCode {
  label: string;
  value: string;
}

interface LanguageOption {
  label: string;
  value: string;
}

interface RowData {
  buttonType: string;
  buttonText: string;
  buttonTypeDropdown: string;
  websiteUrl: string;
  countryCode: string;
  callPhoneNumber: string;
  copyOfferCode: string;
  qrResponse: string;
  qrOptOut: boolean;
}

interface CreateContentWhatsappProps {
  onClose: () => void;
  onSave: (content: any) => void;
  initialContent?: any;
  allTemplates: any[];
  configIdx: number;
}

interface ValidationErrors {
  language: string;
  headerText: string;
  bodyText: string;
  footerText: string;
  mediaFile: string;
  headerContent: string;
}

interface ButtonValidationErrors {
  buttonText: string;
  websiteUrl: string;
  phoneNumber: string;
  countryCode: string;
  copyOfferCode: string;
  general: string;
}

// Utility: Extracts media_config from anywhere in the template
function extractMediaConfig(initialContent: any) {
  let media_config =
    initialContent?.media_config ||
    initialContent?.translated_template?.media_config ||
    initialContent?.template?.media_config ||
    initialContent?._debug_original?.media_config;

  if (
    (!media_config || !media_config.binary_data) &&
    Array.isArray(initialContent?.components)
  ) {
    const headerComp = initialContent.components.find((c: any) => c.type === "HEADER");
    if (headerComp?.media_config?.binary_data) {
      media_config = headerComp.media_config;
    }
  }
  if (
    (!media_config || !media_config.binary_data) &&
    Array.isArray(initialContent?.template?.components)
  ) {
    const headerComp = initialContent.template.components.find((c: any) => c.type === "HEADER");
    if (headerComp?.media_config?.binary_data) {
      media_config = headerComp.media_config;
    }
  }
  return media_config;
}

// Validation helper functions
const containsEmoji = (text: string): boolean => {
  const regex = emojiRegex();
  return regex.test(text);
};

const normalizeUrl = (raw: string) => {
  const v = (raw || "").trim();
  if (!v) return "";
  if (/^https:\/\//i.test(v)) return v;
  if (/^www\./i.test(v)) return `https://${v}`;
  return `https://${v.replace(/^http:\/\//i, "")}`;
};

const containsFormatting = (text: string): boolean => {
  const formattingRegex = /[\*_~`]/;
  return formattingRegex.test(text);
};

const validateLanguage = (language: string): string => {
  if (!language || language.trim() === '') {
    return 'Language selection is required';
  }
  return '';
};

const validateHeaderText = (text: string): string => {
  if (!text || text.trim() === '') return '';

  if (containsEmoji(text)) {
    return 'Header text cannot contain emojis';
  }

  if (containsFormatting(text)) {
    return 'Header text cannot contain formatting characters (*, _, ~, `)';
  }

  return '';
};

const validateBodyText = (text: string): string => {
  if (!text || text.trim() === '') {
    return 'Body text is required';
  }

  if (text.trim().length < 25) {
    return 'Body text must be at least 25 characters long'
  }
  return '';
};

const validateFooterText = (text: string): string => {
  if (!text || text.trim() === '') return '';

  if (containsEmoji(text)) {
    return 'Footer text cannot contain emojis';
  }

  if (containsFormatting(text)) {
    return 'Footer text cannot contain formatting characters (*, _, ~, `)';
  }

  return '';
};

const validateMediaFile = (file: File | null): string => {
  if (!file) return '';

  const maxSize = 5 * 1024 * 1024;
  if (file.size > maxSize) {
    return 'File size must not exceed 5MB';
  }

  return '';
};

const validateHeaderContent = (headerType: string, textInput: string, hasMedia: boolean): string => {
  if (headerType === 'none') return '';

  if (headerType === 'text') {
    if (!textInput || textInput.trim() === '') {
      return 'Header text is required when header type is selected';
    }
  } else if (['image', 'video', 'document'].includes(headerType)) {
    if (!hasMedia) {
      return `${headerType.charAt(0).toUpperCase() + headerType.slice(1)} is required when header type is selected`;
    }
  }

  return '';
};

// Button validation functions
const validateButtonText = (text: string, buttonType: string): string => {
  if (buttonType === 'COPY_CODE') return '';

  const v = (text ?? '').trim();
  if (!v) return 'Button text is required';

  if (v.length > 25) return 'Button text cannot exceed 25 characters';

  if (/(https?:\/\/|www\.)/i.test(v)) return 'Do not put URLs in button text';

  if (!/^[A-Za-z0-9 ]+$/.test(v)) return 'Button text may contain only letters, numbers, and spaces';

  return '';
};

const validateWebsiteUrl = (url: string): string => {
  if (!url || url.trim() === '') {
    return 'Website URL is required';
  }

  const httpsRegex = /^https:\/\//;
  const wwwRegex = /^www\./;

  if (!httpsRegex.test(url) && !wwwRegex.test(url)) {
    return 'URL must start with https:// or www.';
  }

  return '';
};

const validatePhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return 'Phone number is required';
  }

  const numbersOnlyRegex = /^\d+$/;
  if (!numbersOnlyRegex.test(phoneNumber)) {
    return 'Phone number can only contain numbers';
  }

  if (phoneNumber.length < 7 || phoneNumber.length > 15) {
    return 'Phone number must be between 7 and 15 digits';
  }

  return '';
};

const validateCountryCode = (code: string, buttonType: string): string => {
  if (buttonType === "PHONE_NUMBER") {
    if (!code || code.trim() === "") return "Country code is required";
  }
  return "";
};

const validateCopyOfferCode = (code: string): string => {
  const v = (code ?? '').trim();
  if (!v) return 'Offer code is required';

  if (v.length > 15) return 'Offer code cannot exceed 15 characters';

  if (!/^[A-Za-z0-9_-]+$/.test(v)) {
    return 'Only letters, numbers, dashes (-), and underscores (_) are allowed';
  }

  if (containsEmoji(v)) return 'Offer code cannot contain emojis';
  if (/(https?:\/\/|www\.)/i.test(v)) return 'Offer code cannot contain URLs';

  return '';
};

const CreateContentWhatsapp: React.FC<CreateContentWhatsappProps> = ({
  onClose,
  onSave,
  initialContent,
  allTemplates,
  configIdx,
}) => {
  const [language, setLanguage] = useState("");
  const [headerType, setHeaderType] = useState<string>("none");
  const [textInput, setTextInput] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [bodyText, setBodyText] = useState<string>("");
  const [FooterText, setFooterText] = useState<string>("");
  const [rows, setRows] = useState<RowData[]>([]);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [mediaBase64, setMediaBase64] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [showDiscardDialog, setShowDiscardDialog] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [countryCodes, setCountryCodes] = useState<CountryCode[]>([]);
  const [countryCodesLoading, setCountryCodesLoading] = useState(false);
  const [hasFetchedCountryCodes, setHasFetchedCountryCodes] = useState(false);

  const [languages, setLanguages] = useState<LanguageOption[]>([]);
  const [languagesLoading, setLanguagesLoading] = useState(false);
  const [hasFetchedLanguages, setHasFetchedLanguages] = useState(false);

  const [fileName, setFileName] = useState<string>("");
  const [fileType, setFileType] = useState<string>("");
  const [fileLength, setFileLength] = useState<string>("");

  const [validationErrors, setValidationErrors] = useState<ValidationErrors>({
    language: '',
    headerText: '',
    bodyText: '',
    footerText: '',
    mediaFile: '',
    headerContent: ''
  });

  const [buttonValidationErrors, setButtonValidationErrors] = useState<ButtonValidationErrors[]>([]);

  const advUrl = useSelector((state: RootState) => state.authentication.apiURL);

  const hasButtonValidationErrors = (): boolean => {
    return buttonValidationErrors.some(errors =>
      errors.buttonText || errors.websiteUrl || errors.phoneNumber || errors.countryCode || errors.copyOfferCode || errors.general
    );
  };

  const getPhoneNumberButtonCount = (): number => {
    return rows.filter(row => row.buttonType === 'PHONE_NUMBER').length;
  };

  const getUrlButtonCount = (): number =>
    rows.filter(r => r.buttonType === 'URL').length;

  const getCopyCodeButtonCount = (): number =>
    rows.filter(r => r.buttonType === 'COPY_CODE').length;

  const isFormValid = () => {
    const urlsOk = getUrlButtonCount() <= 2;
    const copiesOk = getCopyCodeButtonCount() <= 1;

    return (
      urlsOk &&
      copiesOk &&
      !validationErrors.language &&
      !validationErrors.headerText &&
      !validationErrors.bodyText &&
      !validationErrors.footerText &&
      !validationErrors.mediaFile &&
      !validationErrors.headerContent &&
      !hasButtonValidationErrors() &&
      language.trim() !== '' &&
      bodyText.trim() !== ''
    );
  };

  const handleLanguageChange = (value: string) => {
    setLanguage(value);
    setValidationErrors(prev => ({
      ...prev,
      language: validateLanguage(value)
    }));
  };

  const handleHeaderTextChange = (value: string) => {
    setTextInput(value);
    setValidationErrors(prev => ({
      ...prev,
      headerText: validateHeaderText(value),
      headerContent: validateHeaderContent(headerType, value, !!selectedFile || !!mediaBase64)
    }));
  };

  const handleBodyTextChange = (value: string) => {
    setBodyText(value);
    setValidationErrors(prev => ({
      ...prev,
      bodyText: validateBodyText(value)
    }));
  };

  const handleFooterTextChange = (value: string) => {
    setFooterText(value);
    setValidationErrors(prev => ({
      ...prev,
      footerText: validateFooterText(value)
    }));
  };

  const handleHeaderTypeChange = (value: string) => {
    setHeaderType(value);
    setTextInput("");
    setSelectedFile(null);
    setPreviewImage(null);
    if (value === "none") setMediaBase64("");

    setValidationErrors(prev => ({
      ...prev,
      headerText: '',
      mediaFile: '',
      headerContent: validateHeaderContent(value, "", false)
    }));
  };

  useEffect(() => {
    setButtonValidationErrors(prev => {
      const newErrors = [...prev];
      while (newErrors.length < rows.length) {
        newErrors.push({
          buttonText: '',
          websiteUrl: '',
          phoneNumber: '',
          countryCode: '',
          copyOfferCode: '',
          general: ''
        });
      }
      if (newErrors.length > rows.length) {
        newErrors.splice(rows.length);
      }
      return newErrors;
    });
  }, [rows.length]);

  useEffect(() => {
    if (!initialContent) return;
    if (
      Array.isArray(initialContent?.components) &&
      initialContent.components.some(
        (c: any) =>
          c.type === "BUTTONS" &&
          Array.isArray(c.buttons) &&
          c.buttons.some((btn: any) => btn.type === "PHONE_NUMBER")
      ) &&
      (!countryCodes || countryCodes.length === 0)
    ) {
      return;
    }

    const initialLanguage = initialContent.language || "en";
    setLanguage(initialLanguage);

    setValidationErrors(prev => ({
      ...prev,
      language: validateLanguage(initialLanguage)
    }));

    let components: any[] = [];
    const componentSources = [
      initialContent.components,
      initialContent.template?.components,
      initialContent.translated_template?.template?.components,
      initialContent._originalTemplate?.components,
      initialContent._debug_original?.translated_template?.template?.components,
    ];
    for (const source of componentSources) {
      if (Array.isArray(source)) {
        components = source;
        break;
      }
    }

    const headerComp = components.find((c: any) => c.type === "HEADER");
    if (headerComp) {
      const format = headerComp.format?.toLowerCase() || "none";
      setHeaderType(format);

      if (format === "text") {
        const headerText = headerComp.text || "";
        setTextInput(headerText);
        setValidationErrors(prev => ({
          ...prev,
          headerText: validateHeaderText(headerText),
          headerContent: validateHeaderContent(format, headerText, false),
          mediaFile: ''
        }));
        setMediaBase64("");
        setPreviewImage(null);
        setFileName("");
        setFileType("");
        setFileLength("");
      } else if (["image", "video", "document"].includes(format)) {
        let mediaBase64Value = "";
        let fileNameValue = "";
        let fileTypeValue = "";
        let fileLengthValue = "";

        const mediaConfig = extractMediaConfig(initialContent);

        if (mediaConfig && mediaConfig.binary_data) {
          fileNameValue = mediaConfig.file_name || `media.${format}`;
          fileTypeValue = mediaConfig.file_type || (
            format === "image" ? "image/jpeg" :
              format === "video" ? "video/mp4" :
                format === "document" ? "application/pdf" : ""
          );
          fileLengthValue = mediaConfig.file_length || "";

          const binaryData = mediaConfig.binary_data;
          if (binaryData) {
            if (binaryData.startsWith("data:")) {
              mediaBase64Value = binaryData;
            } else {
              const cleanBase64 = binaryData.replace(/^data:[^,]+,/, "");
              mediaBase64Value = `data:${fileTypeValue};base64,${cleanBase64}`;
            }
          }
        } else if (initialContent.Base64 && initialContent.Base64.length > 0) {
          mediaBase64Value = initialContent.Base64;
          fileTypeValue = format === "image" ? "image/jpeg" :
            format === "video" ? "video/mp4" :
              format === "document" ? "application/pdf" : "";
          fileNameValue = `media.${format}`;
        }

        const hasMedia = !!mediaBase64Value;
        setMediaBase64(mediaBase64Value);
        setPreviewImage(mediaBase64Value);
        setFileName(fileNameValue);
        setFileType(fileTypeValue);
        setFileLength(fileLengthValue);
        setTextInput("");
        setValidationErrors(prev => ({
          ...prev,
          headerText: '',
          headerContent: validateHeaderContent(format, "", hasMedia),
          mediaFile: ''
        }));
      } else {
        setMediaBase64("");
        setPreviewImage(null);
        setTextInput("");
        setFileName("");
        setFileType("");
        setFileLength("");
        setValidationErrors(prev => ({
          ...prev,
          headerText: '',
          headerContent: '',
          mediaFile: ''
        }));
      }
    } else {
      setHeaderType("none");
      setTextInput("");
      setMediaBase64("");
      setPreviewImage(null);
      setFileName("");
      setFileType("");
      setFileLength("");
      setValidationErrors(prev => ({
        ...prev,
        headerText: '',
        headerContent: '',
        mediaFile: ''
      }));
    }

    const bodyComp = components.find((c: any) => c.type === "BODY");
    const initialBodyText = bodyComp?.text || "";
    setBodyText(initialBodyText);
    setValidationErrors(prev => ({
      ...prev,
      bodyText: validateBodyText(initialBodyText)
    }));

    const footerComp = components.find((c: any) => c.type === "FOOTER");
    const initialFooterText = footerComp?.text || "";
    setFooterText(initialFooterText);
    setValidationErrors(prev => ({
      ...prev,
      footerText: validateFooterText(initialFooterText)
    }));

    const btnComp = components.find((c: any) => c.type === "BUTTONS");
    if (btnComp && Array.isArray(btnComp.buttons)) {
      const buttonRows = btnComp.buttons.map((btn: any) => {
        const baseRow = {
          buttonText: "",
          buttonTypeDropdown: "",
          websiteUrl: "",
          countryCode: "",
          callPhoneNumber: "",
          copyOfferCode: "",
          qrResponse: "",
          qrOptOut: false,
        };

        if (btn.type === "URL") {
          return {
            ...baseRow,
            buttonType: "URL",
            buttonText: btn.text || "",
            websiteUrl: btn.url || "",
          };
        } else if (btn.type === "PHONE_NUMBER") {
          const phoneNumber = btn.phone_number || "";
          let foundCode = "";
          let numberPart = phoneNumber;
          if (countryCodes && countryCodes.length > 0 && phoneNumber) {
            const sortedCodes = countryCodes.map(c => c.value).sort((a, b) => b.length - a.length);
            for (const code of sortedCodes) {
              if (phoneNumber.startsWith(code)) {
                foundCode = code;
                numberPart = phoneNumber.substring(code.length);
                break;
              }
            }
          }
          return {
            ...baseRow,
            buttonType: "PHONE_NUMBER",
            buttonText: btn.text || "",
            countryCode: foundCode,
            callPhoneNumber: numberPart,
          };
        } else if (btn.type === "COPY_CODE") {
          return {
            ...baseRow,
            buttonType: "COPY_CODE",
            buttonText: "Copy",
            copyOfferCode: btn.example || "",
          };
        } else if (btn.type === "QUICK_REPLY") {
          const isActuallyCopyCode = btn.text === "Copy";
          if (isActuallyCopyCode) {
            let offerCode = "";
            const originalTemplate = initialContent?.template || initialContent;
            if (originalTemplate?.components) {
              const origBtnComp = originalTemplate.components.find((c: any) => c.type === "BUTTONS");
              if (origBtnComp?.buttons) {
                const copyBtn = origBtnComp.buttons.find((b: any) => b.type === "COPY_CODE");
                if (copyBtn) {
                  offerCode = copyBtn.example || "";
                }
              }
            }
            return {
              ...baseRow,
              buttonType: "COPY_CODE",
              buttonText: "Copy",
              copyOfferCode: offerCode,
              qrResponse: "",
              qrOptOut: false,
            };
          } else {
            const qrData = Array.isArray(initialContent?.qr)
              ? initialContent.qr.find((q: any) => q.label === btn.text)
              : null;

            return {
              ...baseRow,
              buttonType: "QUICK_REPLY",
              buttonText: btn.text || "",
              qrResponse: qrData?.response || "",
              qrOptOut: qrData?.opt_out ?? false,
            };
          }
        }
        return baseRow;
      });
      setRows(buttonRows);
    } else {
      setRows([]);
    }

    setSelectedFile(null);
  }, [initialContent, countryCodes]);

  useEffect(() => {
    if (!hasFetchedCountryCodes && !countryCodesLoading) {
      fetchCountryCodes();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!hasFetchedLanguages && !languagesLoading) {
      fetchLanguages();
    }
  }, []);

  const fetchCountryCodes = async () => {
    setCountryCodesLoading(true);
    try {
      const response = await axios.get(`${advUrl}/GetAllCountryCodes`);
      if (response.data.status === "Success") {
        setCountryCodes(response.data.country_codes);
        setHasFetchedCountryCodes(true);
      } else {
        setCountryCodes([]);
        toast({
          title: "Error",
          description: "Unable to fetch country codes.",
        });
      }
    } catch (error: any) {
      setCountryCodes([]);
      toast({
        title: "Error",
        description: "Error fetching country codes.",
      });
    } finally {
      setCountryCodesLoading(false);
    }
  };

  const fetchLanguages = async () => {
    setLanguagesLoading(true);
    try {
      const response = await axios.get(`${advUrl}/GetLanguages`);
      if (response.data.status === "Success") {
        setLanguages(response.data.languages);
        setHasFetchedLanguages(true);
      } else {
        setLanguages([]);
        toast({
          title: "Error",
          description: "Unable to fetch languages.",
        });
      }
    } catch (error) {
      setLanguages([]);
      toast({
        title: "Error",
        description: "Error fetching languages.",
      });
    } finally {
      setLanguagesLoading(false);
    }
  };

  const maxLength = 60;

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const mediaFileError = validateMediaFile(file);

      if (mediaFileError) {
        setValidationErrors(prev => ({
          ...prev,
          mediaFile: mediaFileError,
          headerContent: validateHeaderContent(headerType, textInput, false)
        }));
        setSelectedFile(null);
        setFileName('');
        setFileType('');
        setFileLength('');
        setPreviewImage(null);
        setMediaBase64('');
        if (fileInputRef.current) fileInputRef.current.value = '';
        return;
      }

      setSelectedFile(file);
      setFileName(file.name);
      setFileType(file.type);
      setFileLength(file.size.toString());

      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => setPreviewImage(e.target?.result as string);
        reader.readAsDataURL(file);
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = (e.target?.result as string)?.split(",")[1] || "";
        setMediaBase64(base64);
      };
      reader.readAsDataURL(file);

      setValidationErrors(prev => ({
        ...prev,
        mediaFile: '',
        headerContent: validateHeaderContent(headerType, textInput, true)
      }));
    }
  };

  const onEmojiClick = (emojiObject: any) => {
    setBodyText((prev) => prev + emojiObject.emoji);
    setShowPicker(false);
  };

  const insertFormattingTags = (startTag: string, endTag: string) => {
    const textarea = document.querySelector('textarea[name="bodyText"]') as HTMLTextAreaElement;
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    const replacement = startTag + selectedText + endTag;
    const newValue = textarea.value.substring(0, start) + replacement + textarea.value.substring(end);
    handleBodyTextChange(newValue);
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + startTag.length, start + startTag.length + selectedText.length);
    }, 0);
  };

  const addButtonRow = () => {
    if (rows.length < 3) {
      setRows([...rows, {
        buttonType: "",
        buttonText: "",
        buttonTypeDropdown: "static",
        websiteUrl: "",
        countryCode: "",
        callPhoneNumber: "",
        copyOfferCode: "",
        qrResponse: "",
        qrOptOut: false,
      }]);
    }
  };

  const removeButtonRow = (index: number) => {
    setRows(rows.filter((_, i) => i !== index));
    setButtonValidationErrors(prev => prev.filter((_, i) => i !== index));
  };

  debugger;
  const updateButtonRow = (index: number, field: keyof RowData, value: string | boolean) => {
    if (field === 'buttonType' && value === 'PHONE_NUMBER') {
      const currentPhoneCount = getPhoneNumberButtonCount();
      if (currentPhoneCount >= 1 && rows[index].buttonType !== 'PHONE_NUMBER') {
        setButtonValidationErrors(prev => {
          const next = [...prev];
          next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
          next[index].general = 'Only one phone number button is allowed per template';
          return next;
        });
        return;
      }
    }

    if (field === 'buttonType' && value === 'URL') {
      const currentUrlCount = getUrlButtonCount();
      if (currentUrlCount >= 2 && rows[index].buttonType !== 'URL') {
        setButtonValidationErrors(prev => {
          const next = [...prev];
          next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
          next[index].general = 'Only two website buttons are allowed per template';
          return next;
        });
        return;
      }
    }

    if (field === 'buttonType' && value === 'COPY_CODE') {
      const currentCopyCount = getCopyCodeButtonCount();
      if (currentCopyCount >= 1 && rows[index].buttonType !== 'COPY_CODE') {
        setButtonValidationErrors(prev => {
          const next = [...prev];
          next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
          next[index].general = 'Only one copy offer code button is allowed per template';
          return next;
        });
        return;
      }
    }

    if (field === 'buttonType' && value === 'QUICK_REPLY') {
      const currentQRCount = rows.filter(r => r.buttonType === 'QUICK_REPLY').length;
      if (currentQRCount >= 3 && rows[index].buttonType !== 'QUICK_REPLY') {
        setButtonValidationErrors(prev => {
          const next = [...prev];
          next[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
          next[index].general = 'Only three quick reply button is allowed per template';
          return next;
        });
        return;
      }
    }

    const nextRows = rows.map((row, i) => {
      if (i !== index) return row;
      const updated = { ...row, [field]: value };
      if (field === 'buttonType' && value === 'COPY_CODE') updated.buttonText = 'Copy';
      return updated;
    });
    setRows(nextRows);

    setButtonValidationErrors(prev => {
      const newErrors = [...prev];
      newErrors[index] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };

      if (field === 'buttonType') {
        newErrors[index] = { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
        if (value === 'PHONE_NUMBER') {
          newErrors[index].countryCode = validateCountryCode(nextRows[index].countryCode, 'PHONE_NUMBER');
          newErrors[index].phoneNumber = validatePhoneNumber(nextRows[index].callPhoneNumber);
          newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, 'PHONE_NUMBER');
        }
        if (value === 'URL') {
          newErrors[index].websiteUrl = validateWebsiteUrl(nextRows[index].websiteUrl);
          newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, 'URL');
        }
        if (value === 'COPY_CODE') {
          newErrors[index].copyOfferCode = validateCopyOfferCode(nextRows[index].copyOfferCode);
          newErrors[index].buttonText = '';
        }
        if (value === 'QUICK_REPLY') {
          newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, 'QUICK_REPLY');
        }
      } else {
        switch (field) {
          case 'buttonText': {
            // ✅ Rule 1: Check for duplicate QUICK_REPLY button text
            const currentButtonType = nextRows[index].buttonType;
            if (currentButtonType === 'QUICK_REPLY') {
              const currentText = (nextRows[index].buttonText ?? '').trim().toLowerCase();
              const isDuplicate = nextRows.some(
                (r, i) =>
                  i !== index &&
                  r.buttonType === 'QUICK_REPLY' &&
                  (r.buttonText ?? '').trim().toLowerCase() === currentText &&
                  currentText !== ''
              );

              if (isDuplicate) {
                newErrors[index].buttonText = 'Quick reply button text must be unique.';
                // Also flag the other button(s) that share the same text
                nextRows.forEach((r, i) => {
                  if (
                    i !== index &&
                    r.buttonType === 'QUICK_REPLY' &&
                    (r.buttonText ?? '').trim().toLowerCase() === currentText
                  ) {
                    newErrors[i] ??= { buttonText: '', websiteUrl: '', phoneNumber: '', countryCode: '', copyOfferCode: '', general: '' };
                    newErrors[i].buttonText = 'Quick reply button text must be unique.';
                  }
                });
              } else {
                // No duplicate — run standard button text validation
                newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, currentButtonType);
                // Also clear duplicate error on other QR buttons that may have been flagged
                nextRows.forEach((r, i) => {
                  if (i !== index && r.buttonType === 'QUICK_REPLY') {
                    // Re-check if that button is still a duplicate with anyone else
                    const otherText = (r.buttonText ?? '').trim().toLowerCase();
                    const stillDuplicate = nextRows.some(
                      (r2, i2) =>
                        i2 !== i &&
                        r2.buttonType === 'QUICK_REPLY' &&
                        (r2.buttonText ?? '').trim().toLowerCase() === otherText &&
                        otherText !== ''
                    );
                    if (!stillDuplicate && newErrors[i]?.buttonText === 'Quick reply button text must be unique.') {
                      newErrors[i].buttonText = '';
                    }
                  }
                });
              }
            } else {
              newErrors[index].buttonText = validateButtonText(nextRows[index].buttonText, currentButtonType);
            }
            break;
          }
          case 'websiteUrl':
            newErrors[index].websiteUrl = validateWebsiteUrl(nextRows[index].websiteUrl);
            break;
          case 'countryCode':
            newErrors[index].countryCode = validateCountryCode(nextRows[index].countryCode, nextRows[index].buttonType);
            break;
          case 'callPhoneNumber':
            newErrors[index].phoneNumber = validatePhoneNumber(nextRows[index].callPhoneNumber);
            newErrors[index].countryCode = validateCountryCode(nextRows[index].countryCode, nextRows[index].buttonType);
            break;
          case 'copyOfferCode':
            newErrors[index].copyOfferCode = validateCopyOfferCode(nextRows[index].copyOfferCode);
            break;
        }
      }
      return newErrors;
    });
  };

  const renderFormattedText = (text: string) =>
    text
      .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
      .replace(/_([^_]+)_/g, '<em>$1</em>')
      .replace(/~([^~]+)~/g, '<s>$1</s>')
      .replace(/`([^`]+)`/g, '<code style="background: #f1f1f1; padding: 2px 4px; border-radius: 3px;">$1</code>')
      .replace(/\{\{(\d+)\}\}/g, '<span style="background: #e3f2fd; padding: 2px 4px; border-radius: 3px; color: #1976d2;">{{$1}}</span>');

  const noContentSelected =
    !textInput.trim() && !previewImage && !selectedFile && !mediaBase64 &&
    !bodyText.trim() && !FooterText.trim() &&
    rows.filter(row => row.buttonText.trim()).length === 0;

  const handleSubmitWhatsApp = () => {
    if (!isFormValid()) {
      toast({
        title: "Validation Error",
        description: "Please fix all validation errors before saving.",
      });
      return;
    }

    const newName =
      initialContent?.name ||
      initialContent?.template?.name ||
      initialContent?.translated_template?.template?.name ||
      "whatsapp_template";

    let media_config = {
      file_name: "",
      file_type: "",
      binary_data: "",
      file_length: "",
    };

    if (
      (headerType === "image" || headerType === "video" || headerType === "document") &&
      (mediaBase64 || selectedFile)
    ) {
      let fileTypeToUse = fileType;
      let fileNameToUse = fileName;
      let fileLengthToUse = fileLength;

      if (selectedFile) {
        fileTypeToUse = selectedFile.type;
        fileNameToUse = selectedFile.name;
        fileLengthToUse = selectedFile.size ? selectedFile.size.toString() : "";
      }
      let base64Data = mediaBase64;
      if (mediaBase64 && !mediaBase64.startsWith("data:")) {
        base64Data = `data:${fileTypeToUse};base64,${mediaBase64}`;
      }

      media_config = {
        file_name: fileNameToUse,
        file_type: fileTypeToUse,
        binary_data: base64Data,
        file_length: fileLengthToUse,
      };
    }

    if (!(headerType === "image" || headerType === "video" || headerType === "document")) {
      media_config = {
        file_name: "",
        file_type: "",
        binary_data: "",
        file_length: "",
      };
    }

    const phone_id = initialContent?.phone_id || "";
    const channel_config_id = initialContent?.channel_config_id || "";
    const template_id = initialContent?.template_id || "";

    debugger;
    const qrButtons = rows
      .filter(row => row.buttonType === "QUICK_REPLY" && row.buttonText.trim())
      .map(row => ({
        label: row.buttonText,
        opt_out: row.qrOptOut ?? false,
        response: row.qrResponse
      }));

    const template: any = {
      template_id,
      name: newName,
      language,
      category: "MARKETING",
      Base64: mediaBase64 || "",
      components: [],
      media_config,
      phone_id,
      channel_config_id,
    };

    if (headerType && headerType !== "none") {
      const headerObj: any = {
        type: "HEADER",
        format: headerType?.toUpperCase()
      };
      if (headerType === "text") headerObj.text = textInput;
      template.components.push(headerObj);
    }
    template.components.push({ type: "BODY", text: bodyText });
    if (FooterText) template.components.push({ type: "FOOTER", text: FooterText });

    const buttons = rows.filter(row =>
      row.buttonText.trim() ||
      (row.buttonType === 'COPY_CODE' && row.copyOfferCode.trim())
    ).map(row => {
      if (row.buttonType === "URL") {
        const href = normalizeUrl(row.websiteUrl);
        return { type: "URL", text: row.buttonText, url: href };
      } else if (row.buttonType === "PHONE_NUMBER") {
        return { type: "PHONE_NUMBER", text: row.buttonText, phone_number: row.countryCode + row.callPhoneNumber };
      } else if (["COPY_CODE"].includes(row.buttonType)) {
        return { type: "COPY_CODE", example: row.copyOfferCode };
      } else if (row.buttonType === "QUICK_REPLY") {
        return { type: "QUICK_REPLY", text: row.buttonText };
      }
      return {};
    });

    if (buttons.length > 0)
      template.components.push({ type: "BUTTONS", buttons });

    const toSave = {
      ...template,
      phone_id,
      channel_config_id,
      template_id,
      qr: qrButtons
    };
    onSave(toSave);
    onClose();
  };

  const getBase64Src = (type: string) => {
    if (!mediaBase64) return null;
    if (mediaBase64.startsWith("data:")) return mediaBase64;
    if (type === "image") return `data:image/jpeg;base64,${mediaBase64}`;
    if (type === "video") return `data:video/mp4;base64,${mediaBase64}`;
    if (type === "document") return `data:application/pdf;base64,${mediaBase64}`;
    return "";
  };

  console.log("[QR CHECK - CreateContentWhatsappCard initialContent]", JSON.stringify(initialContent?.qr));

  return (
    <>
      <div className="flex flex-col md:flex-row gap-6 mb-6 mt-4">
        <div className="space-y-6 w-full md:w-3/5">
          <Card className="border p-4 rounded-lg text-left">
            <h2 className="text-base font-semibold mb-2">Content</h2>
            <div className="flex-shrink-0">
              <Label htmlFor="language">Language</Label>
              <Select value={language} onValueChange={handleLanguageChange} disabled={languagesLoading}>
                <SelectTrigger className={`text-[#020617] w-1/2 mt-2 ${validationErrors.language ? 'border-red-500' : ''}`}>
                  <SelectValue className="text-[#020617]" placeholder={languagesLoading ? "Loading..." : "Select Language"} />
                </SelectTrigger>
                <SelectContent className="h-48">
                  {languages.map((option: LanguageOption) => (
                    <SelectItem key={option.value} value={option.value} className="cursor-pointer">
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {validationErrors.language && (
                <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.language}</p>
              )}
            </div>
            <div className="space-y-4 mt-4">
              <div>
                <Label>Header</Label>
                <div
                  style={{
                    background: "#F0F4F8",
                    color: "#64748B",
                    padding: "2px 10px",
                    borderRadius: "9999px",
                    display: "inline-flex",
                    alignItems: "center",
                    height: "20px",
                    marginLeft: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Optional
                </div>
                <Select value={headerType} onValueChange={handleHeaderTypeChange}>
                  <SelectTrigger className="w-full text-[#020617] mt-2">
                    <SelectValue placeholder="Select Header Type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none">None</SelectItem>
                    <SelectItem value="text">Text</SelectItem>
                    <SelectItem value="image">Image</SelectItem>
                    <SelectItem value="video">Video</SelectItem>
                    <SelectItem value="document">Document</SelectItem>
                  </SelectContent>
                </Select>
                {validationErrors.headerContent && (
                  <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.headerContent}</p>
                )}
              </div>
              {headerType === "text" && (
                <div>
                  <div className="flex justify-between">
                    <Label>Header Text</Label>
                    <div className="text-xs text-gray-500 mt-0">{textInput.length}/{maxLength}</div>
                  </div>
                  <Input
                    value={textInput}
                    onChange={(e) => handleHeaderTextChange(e.target.value)}
                    placeholder="Enter header text"
                    className={`mt-2 text-[#020617] ${validationErrors.headerText ? 'border-red-500' : ''}`}
                    maxLength={60}
                    disabled={!!mediaBase64}
                  />
                  {validationErrors.headerText && (
                    <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.headerText}</p>
                  )}
                </div>
              )}
              {["image", "video", "document"].includes(headerType) && (
                <div>
                  <Label>Upload {headerType}</Label>
                  <div className="mt-2">
                    <input
                      ref={fileInputRef}
                      type="file"
                      onChange={handleFileChange}
                      accept={
                        headerType === "image"
                          ? "image/*"
                          : headerType === "video"
                            ? "video/*"
                            : ".pdf,.doc,.docx"
                      }
                      className="hidden"
                      disabled={!!mediaBase64}
                    />
                    <Button
                      type="button"
                      variant="outline"
                      onClick={() => fileInputRef.current?.click()}
                      className="w-full border-dashed border-2 h-20 text-[#020617]"
                    >
                      {selectedFile ? (
                        <div className="text-center">
                          <div className="font-medium">{selectedFile.name}</div>
                          <div className="text-sm text-gray-500">
                            {(selectedFile.size / 1024).toFixed(1)} KB
                          </div>
                        </div>
                      ) : (
                        <div className="text-center">
                          <PlusIcon className="mx-auto h-6 w-6 mb-2" />
                          {`Click to upload ${headerType}`}
                        </div>
                      )}
                    </Button>
                    {validationErrors.mediaFile && (
                      <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.mediaFile}</p>
                    )}
                    {(selectedFile || mediaBase64) && (
                      <div className="flex justify-end">
                        <Button
                          type="button"
                          variant="ghost"
                          onClick={() => {
                            setSelectedFile(null);
                            setPreviewImage(null);
                            setMediaBase64('');
                            setFileName('');
                            setFileType('');
                            setFileLength('');
                            if (fileInputRef.current) fileInputRef.current.value = '';
                            setValidationErrors(prev => ({
                              ...prev,
                              mediaFile: '',
                              headerContent: validateHeaderContent(headerType, textInput, false)
                            }));
                          }}
                          className="text-red-500 mt-1 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
                        >
                          <FaTrash className="mr-2" />
                          Remove file
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {/* Body Text */}
              <div>
                <div className="flex justify-between">
                  <Label>Body</Label>
                  <div className="text-xs text-gray-500 mb-1 flex justify-end">{bodyText.length}/1024</div>
                </div>
                <div className="relative mt-2">
                  <Textarea
                    name="bodyText"
                    className={`w-full border rounded p-2 text-[#020617] pr-14 min-h-[120px] max-h-[120px] overflow-y-auto resize-none ${validationErrors.bodyText ? 'border-red-500' : ''}`}
                    maxLength={1024}
                    value={bodyText}
                    placeholder="Hello"
                    onChange={(e) => handleBodyTextChange(e.target.value)}
                  />
                  <div className="absolute mt-2 right-2 flex gap-2">
                    <Smile
                      className="w-4 h-4 cursor-pointer text-gray-600 mb-4 hover:text-gray-800"
                      onClick={() => setShowPicker(!showPicker)}
                    />
                    <FontBoldIcon
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("*", "*")}
                    />
                    <FontItalicIcon
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("_", "_")}
                    />
                    <Strikethrough
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("~", "~")}
                    />
                    <CodeIcon
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("`", "`")}
                    />
                  </div>
                  {showPicker && (
                    <div className="absolute top-full left-0 z-50 mt-2">
                      <EmojiPicker onEmojiClick={onEmojiClick} />
                    </div>
                  )}
                </div>
                {validationErrors.bodyText && (
                  <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.bodyText}</p>
                )}
              </div>
              {/* Footer */}
              <div>
                <div className="flex justify-between mt-8">
                  <div>
                    <Label>Footer</Label>
                    <div
                      style={{
                        background: "#F0F4F8",
                        color: "#64748B",
                        padding: "2px 10px",
                        borderRadius: "9999px",
                        display: "inline-flex",
                        alignItems: "center",
                        height: "20px",
                        marginLeft: "8px",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      Optional
                    </div>
                  </div>
                  <div className="text-xs text-gray-500 mt-0 flex justify-end">{FooterText.length}/60</div>
                </div>
                <Input
                  value={FooterText}
                  onChange={(e) => handleFooterTextChange(e.target.value)}
                  placeholder="Enter footer text"
                  className={`mt-2 text-[#020617] ${validationErrors.footerText ? 'border-red-500' : ''}`}
                  maxLength={60}
                />
                {validationErrors.footerText && (
                  <p className="text-red-500 font-medium text-xs mt-1 italic">{validationErrors.footerText}</p>
                )}
              </div>
              {/* Buttons Section */}
              <div>
                <Label className="text-base font-semibold">Buttons</Label>
                <div
                  style={{
                    background: "#F0F4F8",
                    color: "#64748B",
                    padding: "2px 10px",
                    borderRadius: "9999px",
                    display: "inline-flex",
                    alignItems: "center",
                    height: "20px",
                    marginLeft: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Optional
                </div>
                <div className="space-y-3 mt-2">
                  {rows.map((row, index) => {

                    // ✅ Rule 2: Disable optOut checkbox on this row if any OTHER
                    // Quick Reply row already has qrOptOut checked
                    const anyOtherOptOutChecked = rows.some(
                      (r, i) =>
                        i !== index &&
                        r.buttonType === 'QUICK_REPLY' &&
                        r.qrOptOut === true
                    );

                    return (
                      <div key={index} className="border rounded-lg p-4 bg-gray-50">
                        <div className="flex flex-col space-y-3">
                          {/* General button error */}
                          {buttonValidationErrors[index]?.general && (
                            <p className="text-red-500 font-medium text-xs italic">{buttonValidationErrors[index].general}</p>
                          )}

                          {/* Button Type and Text */}
                          <div className="flex flex-col md:flex-row gap-3">
                            <div className="flex-1">
                              <Label className="text-sm">Action type</Label>
                              <Select
                                value={row.buttonType}
                                onValueChange={(value) => updateButtonRow(index, "buttonType", value)}
                              >
                                <SelectTrigger className="text-[#020617] mt-1">
                                  <SelectValue placeholder="Select action type" />
                                </SelectTrigger>
                                <SelectContent>
                                  <SelectItem value="URL">View Website</SelectItem>
                                  <SelectItem value="PHONE_NUMBER">Call Phone Number</SelectItem>
                                  <SelectItem value="COPY_CODE">Copy Offer Code</SelectItem>
                                  <SelectItem value="QUICK_REPLY">Quick Reply</SelectItem>
                                </SelectContent>
                              </Select>
                            </div>
                            <div className="flex-1">
                              <div className="flex justify-between">
                                <Label className="text-sm">Button text</Label>
                                {(row.buttonType === "URL" || row.buttonType === "PHONE_NUMBER" || row.buttonType === "COPY_CODE") && (
                                  <div className="text-xs text-gray-500 mt-0">
                                    {row.buttonText.length}/25
                                  </div>
                                )}
                              </div>
                              <Input
                                className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.buttonText ? 'border-red-500' : ''}`}
                                placeholder="Button text"
                                value={row.buttonType === "COPY_CODE" ? "Copy" : row.buttonText}
                                onChange={(e) => updateButtonRow(index, "buttonText", e.target.value)}
                                maxLength={25}
                                disabled={row.buttonType === "COPY_CODE"}
                              />
                              {buttonValidationErrors[index]?.buttonText && (
                                <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].buttonText}</p>
                              )}
                            </div>
                          </div>

                          {row.buttonType === "URL" && (
                            <div>
                              <Label className="text-sm">Website URL</Label>
                              <Input
                                className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.websiteUrl ? 'border-red-500' : ''}`}
                                placeholder="https://example.com"
                                value={row.websiteUrl}
                                onChange={(e) => updateButtonRow(index, "websiteUrl", e.target.value)}
                                onBlur={(e) => {
                                  const v = e.target.value.trim();
                                  if (/^www\./i.test(v)) {
                                    updateButtonRow(index, "websiteUrl", `https://${v}`);
                                  }
                                }}
                              />
                              {buttonValidationErrors[index]?.websiteUrl && (
                                <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].websiteUrl}</p>
                              )}
                            </div>
                          )}

                          {row.buttonType === "PHONE_NUMBER" && (
                            <div className="flex gap-3">
                              <div className="w-36">
                                <Label className="text-sm">Country Code</Label>
                                <Select
                                  value={row.countryCode}
                                  onValueChange={(value) => updateButtonRow(index, "countryCode", value)}
                                >
                                  <SelectTrigger className="text-[#020617] mt-1">
                                    <SelectValue placeholder="Select Code" />
                                  </SelectTrigger>
                                  <SelectContent className="h-48">
                                    {countryCodes.map((option: CountryCode) => (
                                      <SelectItem key={option.value} value={option.value} className="cursor-pointer">
                                        {option.label}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                                {buttonValidationErrors[index]?.countryCode && (
                                  <p className="text-red-500 font-medium text-xs mt-1 italic">
                                    {buttonValidationErrors[index].countryCode}
                                  </p>
                                )}
                              </div>
                              <div className="flex-1">
                                <Label className="text-sm">Phone Number</Label>
                                <Input
                                  className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.phoneNumber ? 'border-red-500' : ''}`}
                                  placeholder="Phone number"
                                  value={row.callPhoneNumber}
                                  onChange={(e) => updateButtonRow(index, "callPhoneNumber", e.target.value)}
                                />
                                {buttonValidationErrors[index]?.phoneNumber && (
                                  <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].phoneNumber}</p>
                                )}
                              </div>
                            </div>
                          )}

                          {row.buttonType === "COPY_CODE" && (
                            <div>
                              <div className="flex justify-between">
                                <Label className="text-sm">Offer Code</Label>
                                <div className="text-xs text-gray-500 mt-0">
                                  {row.copyOfferCode.length}/15
                                </div>
                              </div>
                              <Input
                                className={`text-[#020617] mt-1 ${buttonValidationErrors[index]?.copyOfferCode ? 'border-red-500' : ''}`}
                                placeholder="Offer code"
                                value={row.copyOfferCode}
                                onChange={(e) => updateButtonRow(index, "copyOfferCode", e.target.value)}
                              />
                              {buttonValidationErrors[index]?.copyOfferCode && (
                                <p className="text-red-500 font-medium text-xs mt-1 italic">{buttonValidationErrors[index].copyOfferCode}</p>
                              )}
                            </div>
                          )}

                          {row.buttonType === "QUICK_REPLY" && (
                            <div>
                              <div className="flex justify-between items-center mb-1">
                                <Label className="text-sm">Quick Reply Responses</Label>
                                {/* ✅ Rule 2: Disable optOut if any other QR row has qrOptOut checked */}
                                <div className={`flex items-center gap-2 ${anyOtherOptOutChecked ? "cursor-not-allowed" : ""}`}>
                                  <input
                                    type="checkbox"
                                    id={`optout-${index}`}
                                    checked={row.qrOptOut}
                                    onChange={(e) =>
                                      updateButtonRow(index, "qrOptOut" as keyof RowData, e.target.checked as any)
                                    }
                                    className={`w-4 h-4 accent-blue-600 ${anyOtherOptOutChecked ? "pointer-events-none opacity-50" : ""}`}
                                    disabled={anyOtherOptOutChecked}
                                  />
                                  <Label
                                    htmlFor={`optout-${index}`}
                                    className={`text-sm ${anyOtherOptOutChecked ? "cursor-not-allowed text-gray-400" : "cursor-pointer"}`}
                                  >
                                    OptOut
                                  </Label>
                                </div>
                              </div>
                              <Textarea
                                className="text-[#020617] min-h-[80px] resize-none"
                                placeholder="Enter quick reply response..."
                                value={row.qrResponse}
                                onChange={(e) =>
                                  updateButtonRow(index, "qrResponse" as keyof RowData, e.target.value)
                                }
                              />
                            </div>
                          )}

                          {/* Remove button */}
                          <div className="flex justify-end">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => removeButtonRow(index)}
                              className="text-red-500 mt-0 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
                            >
                              <FaTrash className="w-3 h-4 mr-2" /> Delete Button
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {rows.length < 3 && (
                    <Button
                      variant="outline"
                      onClick={addButtonRow}
                      className="w-full mt-2 text-[#3A85F7] border-[#3A85F7] hover:bg-blue-50"
                    >
                      <PlusIcon className="w-4 h-4 mr-2" />
                      Add Button
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Card>
        </div>
        {/* Preview */}
        <div className="w-full md:w-2/5 max-w-[500px] border rounded-lg p-4 max-h-[750px] flex flex-col overflow-hidden">
          <h2 className="mb-2 mt-0 font-bold text-left">Content Preview</h2>
          <div
            className="rounded-2xl p-4 min-h-[350px] overflow-y-auto flex-1"
            style={{
              backgroundImage: `url(${Default_WhatsApp_background})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            {noContentSelected ? (
              <div className="flex w-full h-full items-center justify-center">
                <div className="text-center">
                  <div className="relative w-8 h-8 flex justify-center items-center">
                    <div
                      className="absolute rounded w-[3px] h-8 transform rotate-45"
                      style={{ borderLeft: "3px solid #64748B" }}
                    />
                    <div
                      className="absolute w-[3px] h-4 rounded transform rotate-45 translate-x-2 translate-y-2"
                      style={{ borderLeft: "3px solid #64748B" }}
                    />
                  </div>
                  <div className="mt-6">
                    <p className="text-xl font-semibold">Mobile screen</p>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {headerType === "text" && textInput && (
                  <div className="font-semibold mb-2 text-lg">{textInput}</div>
                )}
                {headerType === "image" && (
                  <div className="mb-2">
                    <img
                      src={selectedFile ? previewImage || "" : getBase64Src("image") || ""}
                      alt="Header"
                      className="w-full h-40 object-cover rounded-lg"
                    />
                  </div>
                )}
                {headerType === "video" && (
                  <div className="mb-2">
                    {selectedFile ? (
                      <video controls className="w-full h-40 object-cover rounded-lg" src={URL.createObjectURL(selectedFile)} />
                    ) : mediaBase64 ? (
                      <video controls className="w-full h-40 object-cover rounded-lg" src={getBase64Src("video") || ""} />
                    ) : null}
                  </div>
                )}
                {headerType === "document" && (
                  <div className="mb-2">
                    {selectedFile ? (
                      <div className="p-3 bg-gray-100 rounded-lg flex items-center space-x-2">
                        <FaFilePdf className="w-6 h-6 text-red-500" />
                        <div>
                          <div className="text-sm font-medium">{selectedFile.name}</div>
                          <div className="text-xs text-gray-500">{(selectedFile.size / 1024).toFixed(1)} KB</div>
                        </div>
                      </div>
                    ) : mediaBase64 ? (
                      <embed src={getBase64Src("document") || ""} type="application/pdf" width="100%" height="200px" className="rounded-lg" />
                    ) : null}
                  </div>
                )}
                {bodyText && (
                  <div
                    className="mb-2 whitespace-pre-wrap break-words text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: renderFormattedText(bodyText) }}
                  />
                )}
                {FooterText && (
                  <div className="text-black font-semibold border-t pt-2 mt-3 text-[14px] flex justify-center">
                    {FooterText}
                  </div>
                )}
                {rows.filter(row =>
                  row.buttonText.trim() ||
                  (row.buttonType === 'COPY_CODE' && row.copyOfferCode.trim())
                ).length > 0 && (
                  <div className="mt-3 space-y-2">
                    {rows.filter(row =>
                      row.buttonText.trim() ||
                      (row.buttonType === 'COPY_CODE' && row.copyOfferCode.trim())
                    ).map((button, index) => (
                      <p
                        key={index}
                        className="font-serif text-blue-400 flex justify-center"
                        style={{ fontSize: "14px" }}
                      >
                        {button.buttonType === 'COPY_CODE' ? 'Copy' : button.buttonText}
                        <div className="border-t mt-2"></div>
                      </p>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* Button Row */}
      <div className="flex justify-end space-x-3 -mt-4 mr-0 h-[40px]">
        <Dialog open={showDiscardDialog} onOpenChange={setShowDiscardDialog}>
          <DialogTrigger asChild>
            <Button
              variant={"outline"}
              className="w-[80px] border-red-500 text-red-500 hover:bg-red-500 hover:text-white mt-0"
              onClick={() => setShowDiscardDialog(true)}
            >
              Discard
            </Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogDescription>
                Are you sure you want to discard this Template?
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <DialogClose asChild>
                <Button type="button" variant="outline" className="w-24">
                  Cancel
                </Button>
              </DialogClose>
              <Button className="w-24" onClick={onClose}>
                OK
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
        <Button
          className={`w-[100px] mt-0 ${isFormValid()
            ? "bg-[#3A85F7] text-white hover:bg-blue-600"
            : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          onClick={handleSubmitWhatsApp}
          disabled={!isFormValid()}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default CreateContentWhatsapp;